/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum WinDoPassConfigType {
  CARD_POSITION_1 = "CARD_POSITION_1",
  CARD_POSITION_2 = "CARD_POSITION_2",
  CARD_POSITION_3 = "CARD_POSITION_3",
  CARD_POSITION_4 = "CARD_POSITION_4",
  CARD_POSITION_5 = "CARD_POSITION_5",
  CONTACT_ABOUT_US_ENABLED = "CONTACT_ABOUT_US_ENABLED",
  CONTACT_ADDRESS_ENABLED = "CONTACT_ADDRESS_ENABLED",
  CONTACT_COLOR = "CONTACT_COLOR",
  CONTACT_COLOR_ORIGIN = "CONTACT_COLOR_ORIGIN",
  CONTACT_EMAIL_ENABLED = "CONTACT_EMAIL_ENABLED",
  CONTACT_ENABLED = "CONTACT_ENABLED",
  CONTACT_IMAGE_ENABLED = "CONTACT_IMAGE_ENABLED",
  CONTACT_IMAGE_ORIGIN = "CONTACT_IMAGE_ORIGIN",
  CONTACT_INFO_ENABLED = "CONTACT_INFO_ENABLED",
  CONTACT_OFFICE_HOURS_ENABLED = "CONTACT_OFFICE_HOURS_ENABLED",
  CONTACT_PHONE_ENABLED = "CONTACT_PHONE_ENABLED",
  CONTACT_WEBSITE_ENABLED = "CONTACT_WEBSITE_ENABLED",
  PRODUCT_INFO_ENABLED = "PRODUCT_INFO_ENABLED",
  PRODUCT_INFO_IMAGE_ENABLED = "PRODUCT_INFO_IMAGE_ENABLED",
  PRODUCT_INFO_GENERAL_DATA_ENABLED = "PRODUCT_INFO_GENERAL_DATA_ENABLED",
  PRODUCT_INFO_PRODUCT_NAME_ENABLED = "PRODUCT_INFO_PRODUCT_NAME_ENABLED",
  PRODUCT_INFO_PRODUCT_YEAR_OF_CONSTRUCTION_ENABLED = "PRODUCT_INFO_PRODUCT_YEAR_OF_CONSTRUCTION_ENABLED",
  PRODUCT_INFO_PRODUCT_MEASUREMENTS_ENABLED = "PRODUCT_INFO_PRODUCT_MEASUREMENTS_ENABLED",
  PRODUCT_INFO_PRODUCT_ORDER_AND_ORDER_LINE_NUMBER_ENABLED = "PRODUCT_INFO_PRODUCT_ORDER_AND_ORDER_LINE_NUMBER_ENABLED",
  PRODUCT_INFO_PRODUCT_DESCRIPTION_ENABLED = "PRODUCT_INFO_PRODUCT_DESCRIPTION_ENABLED",
  PRODUCT_INFO_PRODUCT_PROFILE_SYSTEM_ENABLED = "PRODUCT_INFO_PRODUCT_PROFILE_SYSTEM_ENABLED",
  PRODUCT_INFO_PRODUCT_WOOD_TYPE_ENABLED = "PRODUCT_INFO_PRODUCT_WOOD_TYPE_ENABLED",
  PRODUCT_INFO_GLASS_ENABLED = "PRODUCT_INFO_GLASS_ENABLED",
  PRODUCT_INFO_GLASS_DESCRIPTION_ENABLED = "PRODUCT_INFO_GLASS_DESCRIPTION_ENABLED",
  PRODUCT_INFO_GLASS_HEIGHT_ENABLED = "PRODUCT_INFO_GLASS_HEIGHT_ENABLED",
  PRODUCT_INFO_GLASS_WIDTH_ENABLED = "PRODUCT_INFO_GLASS_WIDTH_ENABLED",
  PRODUCT_INFO_GLASS_DEPTH_ENABLED = "PRODUCT_INFO_GLASS_DEPTH_ENABLED",
  PRODUCT_INFO_GLASS_LONG_TEXT_ENABLED = "PRODUCT_INFO_GLASS_LONG_TEXT_ENABLED",
  PRODUCT_INFO_GLASS_SALES_TEXT_ENABLED = "PRODUCT_INFO_GLASS_SALES_TEXT_ENABLED",
  PRODUCT_INFO_GLASS_SHORT_TEXT_ENABLED = "PRODUCT_INFO_GLASS_SHORT_TEXT_ENABLED",
  PRODUCT_INFO_GLASS_SPECIAL_GLASS_01_ENABLED = "PRODUCT_INFO_GLASS_SPECIAL_GLASS_01_ENABLED",
  PRODUCT_INFO_GLASS_SPECIAL_GLASS_02_ENABLED = "PRODUCT_INFO_GLASS_SPECIAL_GLASS_02_ENABLED",
  PRODUCT_INFO_FILES_ENABLED = "PRODUCT_INFO_FILES_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_ACCEPTANCE_PROTOCOL_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_ACCEPTANCE_PROTOCOL_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_ACCESSORIES_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_ACCESSORIES_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_APPOINTMENTS_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_APPOINTMENTS_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_BROCHURE_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_BROCHURE_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_CERTIFICATES_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_CERTIFICATES_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_COMMERCIAL_DATA_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_COMMERCIAL_DATA_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_COMPLAINT_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_COMPLAINT_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_GENERAL_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_GENERAL_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_WARRANTY_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_WARRANTY_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_GUARANTEES_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_GUARANTEES_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_INSTRUCTION_SHEET_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_INSTRUCTION_SHEET_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_OTHERS_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_OTHERS_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_PRODUCT_PREVIEW_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_PRODUCT_PREVIEW_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_SERVICES_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_SERVICES_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_SKETCH_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_SKETCH_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_SUSTAINABILITY_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_SUSTAINABILITY_ENABLED",
  PRODUCT_DETAILS_ENABLED = "PRODUCT_DETAILS_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_ENABLED",
  PRODUCT_DETAILS_ACCESSORIES_ENABLED = "PRODUCT_DETAILS_ACCESSORIES_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_CUSTOMER_TEXT_ENABLED = "PRODUCT_DETAILS_ACCESSORY_CUSTOMER_TEXT_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_HEIGHT_ENABLED = "PRODUCT_DETAILS_ACCESSORY_HEIGHT_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_NET_PRICE_ENABLED = "PRODUCT_DETAILS_ACCESSORY_NET_PRICE_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_NOTE_ENABLED = "PRODUCT_DETAILS_ACCESSORY_NOTE_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_QUANTITY_ENABLED = "PRODUCT_DETAILS_ACCESSORY_QUANTITY_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_TEXT_LONG_ENABLED = "PRODUCT_DETAILS_ACCESSORY_TEXT_LONG_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_TEXT_SHORT_ENABLED = "PRODUCT_DETAILS_ACCESSORY_TEXT_SHORT_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_TITLE_ENABLED = "PRODUCT_DETAILS_ACCESSORY_TITLE_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_WEIGHT_ENABLED = "PRODUCT_DETAILS_ACCESSORY_WEIGHT_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_WIDTH_ENABLED = "PRODUCT_DETAILS_ACCESSORY_WIDTH_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENTS_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENTS_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_DESIGN_TEXT_ALU_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_DESIGN_TEXT_ALU_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_DESIGN_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_DESIGN_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_HEIGHT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_HEIGHT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_TYPE_ALU_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_TYPE_ALU_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_TYPE_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_TYPE_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_WIDTH_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_WIDTH_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAMES_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAMES_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_DESIGN_TEXT_ALU_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_DESIGN_TEXT_ALU_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_DESIGN_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_DESIGN_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_HEIGHT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_HEIGHT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_TYPE_ALU_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_TYPE_ALU_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_TYPE_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_TYPE_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_WIDTH_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_WIDTH_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTINGS_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTINGS_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ORDER_NUMBER_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ORDER_NUMBER_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ORDER_NUMBER_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ORDER_NUMBER_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_TYPE_VALUE_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_TYPE_VALUE_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_TYPE_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_TYPE_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ARTICLE_VALUE_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ARTICLE_VALUE_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ARTICLE_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ARTICLE_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_MANUFACTURER_VALUE_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_MANUFACTURER_VALUE_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_MANUFACTURER_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_MANUFACTURER_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_SORTING_INDICATOR_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_SORTING_INDICATOR_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_LENGTH_1_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_LENGTH_1_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_LENGTH_2_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_LENGTH_2_ENABLED",
  PRODUCT_DETAILS_FILES_ENABLED = "PRODUCT_DETAILS_FILES_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_ACCEPTANCE_PROTOCOL_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_ACCEPTANCE_PROTOCOL_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_ACCESSORIES_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_ACCESSORIES_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_APPOINTMENTS_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_APPOINTMENTS_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_BROCHURE_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_BROCHURE_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_CERTIFICATES_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_CERTIFICATES_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_COMMERCIAL_DATA_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_COMMERCIAL_DATA_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_COMPLAINT_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_COMPLAINT_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_GENERAL_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_GENERAL_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_WARRANTY_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_WARRANTY_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_GUARANTEES_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_GUARANTEES_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_INSTRUCTION_SHEET_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_INSTRUCTION_SHEET_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_OTHERS_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_OTHERS_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_PRODUCT_PREVIEW_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_PRODUCT_PREVIEW_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_SERVICES_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_SERVICES_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_SKETCH_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_SKETCH_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_SUSTAINABILITY_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_SUSTAINABILITY_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASSES_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASSES_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_DEPTH_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_DEPTH_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_DESCRIPTION_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_DESCRIPTION_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_HEIGHT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_HEIGHT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_LONG_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_LONG_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SALES_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SALES_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SHORT_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SHORT_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SPECIAL_GLASS_01_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SPECIAL_GLASS_01_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SPECIAL_GLASS_02_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SPECIAL_GLASS_02_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_WIDTH_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_WIDTH_ENABLED",
  RECYCLING_ACTION_ENABLED = "RECYCLING_ACTION_ENABLED",
  RECYCLING_ENABLED = "RECYCLING_ENABLED",
  RECYCLING_PARTNER_ENABLED = "RECYCLING_PARTNER_ENABLED",
  REQUEST_ENABLED = "REQUEST_ENABLED",
  SYSTEM_PROVIDER_ENABLED = "SYSTEM_PROVIDER_ENABLED",
  WINDOW_BUILDER_ACTION_ENABLED = "WINDOW_BUILDER_ACTION_ENABLED",
  WINDOW_BUILDER_ENABLED = "WINDOW_BUILDER_ENABLED",
  COLLECTION_PARTNER_ENABLED = "COLLECTION_PARTNER_ENABLED",
  FILES_ENABLED = "FILES_ENABLED",
}

export enum SubscriptionType {
  WIN_DO_PASS = "WIN_DO_PASS",
  WIN_DO_WORKS = "WIN_DO_WORKS",
  WIN_DO_WORKS_LIGHT = "WIN_DO_WORKS_LIGHT",
}

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  MERGE = "MERGE",
  DELETE = "DELETE",
  HEAD = "HEAD",
}

export enum ScanStatusType {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export enum ScanType {
  QR = "QR",
  NFC = "NFC",
}

export enum Salutation {
  MALE = "MALE",
  FEMALE = "FEMALE",
  DIVERS = "DIVERS",
}

export enum DayOfWeek {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}

export enum AppointmentSeriesRepetitionType {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}

export enum RuleOptionCheckValue {
  PART = "PART",
  PRECISE = "PRECISE",
  START = "START",
}

export enum ErpInterface {
  CANTOR = "CANTOR",
  GENERIC = "GENERIC",
  KLAES = "KLAES",
}

export enum ErpConfigTypeCoupleElements {
  MERGE = "MERGE",
  SPLIT = "SPLIT",
}

export enum AddressType {
  CUSTOMER = "CUSTOMER",
  DELIVERY = "DELIVERY",
}

export enum AccessoryFieldRuleCheckType {
  ARTICLE = "ARTICLE",
  PROPERTY = "PROPERTY",
}

export enum AccessoryFieldRuleCheck {
  DESCRIPTION_1 = "DESCRIPTION_1",
  DESCRIPTION_2 = "DESCRIPTION_2",
  DESCRIPTION_3 = "DESCRIPTION_3",
  DESCRIPTION_4 = "DESCRIPTION_4",
}

export enum ValueType {
  PRIMITIVE = "PRIMITIVE",
  GEOSPATIAL = "GEOSPATIAL",
  ENUM = "ENUM",
  COMPLEX = "COMPLEX",
  ENTITY = "ENTITY",
  COLLECTION_PRIMITIVE = "COLLECTION_PRIMITIVE",
  COLLECTION_GEOSPATIAL = "COLLECTION_GEOSPATIAL",
  COLLECTION_ENUM = "COLLECTION_ENUM",
  COLLECTION_COMPLEX = "COLLECTION_COMPLEX",
  COLLECTION_ENTITY = "COLLECTION_ENTITY",
}

export enum UserType {
  INSTALLER = "INSTALLER",
  PLANNER = "PLANNER",
  CLERK = "CLERK",
  ADMINISTRATOR = "ADMINISTRATOR",
}

export enum UomMetreType {
  CENTIMETER = "CENTIMETER",
  DECIMETER = "DECIMETER",
  KILOMETER = "KILOMETER",
  METER = "METER",
  MILLIMETER = "MILLIMETER",
}

export enum Type {
  ACTION = "ACTION",
  FUNCTION = "FUNCTION",
}

export enum SignatureType {
  CLIENT = "CLIENT",
  CONTRACTOR = "CONTRACTOR",
}

export enum ResourceCategory {
  OTHERS = "OTHERS",
  TEMPORARY_WORKER = "TEMPORARY_WORKER",
  TOOL = "TOOL",
  VEHICLE = "VEHICLE",
}

export enum ProjectStatus {
  OPEN = "OPEN",
  IN_PROCESS = "IN_PROCESS",
  CLOSED = "CLOSED",
}

export enum ProductCategory {
  WINDOW = "WINDOW",
  DOOR = "DOOR",
  SLIDINGDOOR = "SLIDINGDOOR",
  OTHERS = "OTHERS",
}

export enum PlanningStatus {
  UNPLANNED = "UNPLANNED",
  PLANABLE = "PLANABLE",
  REQUESTED = "REQUESTED",
  RESERVED = "RESERVED",
  PLANNED = "PLANNED",
}

export enum OrderType {
  DOCUMENTATION = "DOCUMENTATION",
  INTERNAL = "INTERNAL",
  MAINTENANCE = "MAINTENANCE",
  MEASUREMENT = "MEASUREMENT",
  OFFER = "OFFER",
  COMPLAINT = "COMPLAINT",
  PICKUP = "PICKUP",
  QUOTATION = "QUOTATION",
  REMAINING = "REMAINING",
  SERVICE = "SERVICE",
}

export enum OrderStatus {
  OPEN = "OPEN",
  IN_PROCESS = "IN_PROCESS",
  CLOSED = "CLOSED",
}

export enum OrderOriginType {
  CONTRACT = "CONTRACT",
  DOCUMENTATION = "DOCUMENTATION",
}

export enum OrderOrderMappingType {
  BLOCKED_BY = "BLOCKED_BY",
  BLOCKS = "BLOCKS",
  COPIED_BY = "COPIED_BY",
  COPIES = "COPIES",
  SPLIT_BY = "SPLIT_BY",
  SPLITS = "SPLITS",
  CAUSED_BY = "CAUSED_BY",
  CAUSES = "CAUSES",
  RELATED_TO = "RELATED_TO",
}

export enum OrderLineStatus {
  OPEN = "OPEN",
  IN_PROCESS = "IN_PROCESS",
  CLOSED = "CLOSED",
}

export enum OrderLineInternalAcceptanceStatus {
  NULL = "NULL",
  OPEN = "OPEN",
  IN_PROCESS = "IN_PROCESS",
  CLOSED = "CLOSED",
}

export enum OrderLineAcceptanceStatus {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
}

export enum OrderAcceptanceStatus {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
}

export enum NoteType {
  OTHERS = "OTHERS",
  ISSUE = "ISSUE",
  TASK = "TASK",
  INFO = "INFO",
  PROCESS_HISTORY = "PROCESS_HISTORY",
}

export enum NoteStatus {
  CLOSED = "CLOSED",
  IN_PROCESS = "IN_PROCESS",
  OPEN = "OPEN",
}

export enum Language {
  GERMAN = "GERMAN",
  ENGLISH = "ENGLISH",
  CZECH = "CZECH",
  SPANISH = "SPANISH",
  FRENCH = "FRENCH",
  ITALIAN = "ITALIAN",
  DUTCH = "DUTCH",
  POLISH = "POLISH",
  ROMANIAN = "ROMANIAN",
  RUSSIAN = "RUSSIAN",
  SERBIAN = "SERBIAN",
  SLOVAK = "SLOVAK",
  SLOVENIAN = "SLOVENIAN",
  UKRAINIAN = "UKRAINIAN",
}

export enum InstanceType {
  ACCESSORY_FIELD_RULE = "ACCESSORY_FIELD_RULE",
  ACCESSORY_IGNORE_RULE = "ACCESSORY_IGNORE_RULE",
  APPOINTMENT = "APPOINTMENT",
  APPOINTMENT_CONFIG = "APPOINTMENT_CONFIG",
  APPOINTMENT_CONFIG_PROPERTY = "APPOINTMENT_CONFIG_PROPERTY",
  CLIENT = "CLIENT",
  CLIENT_CONFIGURATION = "CLIENT_CONFIGURATION",
  COMPONENT = "COMPONENT",
  COMPONENT_LABEL = "COMPONENT_LABEL",
  CONFIGURATION = "CONFIGURATION",
  CONTACT = "CONTACT",
  CONTAINER = "CONTAINER",
  CONTENT_CENTER = "CONTENT_CENTER",
  CONTENT_CENTER_TEXT = "CONTENT_CENTER_TEXT",
  DOCUMENTATION = "DOCUMENTATION",
  DOCUMENTATION_INPUT = "DOCUMENTATION_INPUT",
  ENTITY_GENERATOR = "ENTITY_GENERATOR",
  ENTITY_MERGER = "ENTITY_MERGER",
  ERP_CASEMENT = "ERP_CASEMENT",
  ERP_COVER_FRAME = "ERP_COVER_FRAME",
  ERP_DOCUMENT = "ERP_DOCUMENT",
  ERP_DOCUMENT_LINE = "ERP_DOCUMENT_LINE",
  ERP_GLASS = "ERP_GLASS",
  ERP_TIME = "ERP_TIME",
  ERP_TRANSFER = "ERP_TRANSFER",
  FILE = "FILE",
  FORM = "FORM",
  NOTE = "NOTE",
  ORDER = "ORDER",
  ORDER_LINE = "ORDER_LINE",
  ORDER_LABEL = "ORDER_LABEL",
  PARTNER_DATA = "PARTNER_DATA",
  PRODUCT = "PRODUCT",
  PRODUCT_LABEL = "PRODUCT_LABEL",
  PRODUCT_LANGUAGE = "PRODUCT_LANGUAGE",
  PROJECT = "PROJECT",
  RESOURCE = "RESOURCE",
  RULE = "RULE",
  TEAM = "TEAM",
  TEAM_MEMBER = "TEAM_MEMBER",
  TIME_RECORD = "TIME_RECORD",
  USER = "USER",
  VALUE_HELP = "VALUE_HELP",
  VALUE_HELP_TEXT = "VALUE_HELP_TEXT",
}

export enum FormType {
  APPOINTMENT_REQUEST = "APPOINTMENT_REQUEST",
  COMPLAINT = "COMPLAINT",
  COMPLAINT_REQUEST = "COMPLAINT_REQUEST",
  DEFAULT = "DEFAULT",
  EXTERNAL_ACCEPTANCE = "EXTERNAL_ACCEPTANCE",
  GENERAL_REQUEST = "GENERAL_REQUEST",
  GUARANTEE_REQUEST = "GUARANTEE_REQUEST",
  INSTALLER = "INSTALLER",
  INSTALLER_REPORT = "INSTALLER_REPORT",
  INTERNAL_ACCEPTANCE = "INTERNAL_ACCEPTANCE",
  MAINTENANCE = "MAINTENANCE",
  MAINTENANCE_REQUEST = "MAINTENANCE_REQUEST",
  MEASUREMENT = "MEASUREMENT",
  OFFER = "OFFER",
  PARTIAL_ACCEPTANCE = "PARTIAL_ACCEPTANCE",
  PICKUP = "PICKUP",
  QUOTATION = "QUOTATION",
  REMAINING = "REMAINING",
  SERVICE = "SERVICE",
  SERVICE_REQUEST = "SERVICE_REQUEST",
}

export enum FormInputType {
  CHECK = "CHECK",
  DATE = "DATE",
  FILE = "FILE",
  PARENT = "PARENT",
  LABEL = "LABEL",
  RADIO = "RADIO",
  RATING = "RATING",
  TEXT = "TEXT",
}

export enum FormCategory {
  INSTALLER_REPORT = "INSTALLER_REPORT",
  SERVICE_REQUEST = "SERVICE_REQUEST",
  INTERNAL_ACCEPTANCE = "INTERNAL_ACCEPTANCE",
  PARTIAL_ACCEPTANCE = "PARTIAL_ACCEPTANCE",
  EXTERNAL_ACCEPTANCE = "EXTERNAL_ACCEPTANCE",
  DOCUMENTATION = "DOCUMENTATION",
  ACCEPTANCE = "ACCEPTANCE",
  ACCEPTANCE_OLD = "ACCEPTANCE_OLD",
}

export enum FileType {
  APPLICATION_PDF = "APPLICATION_PDF",
  BMP = "BMP",
  EMF = "EMF",
  IMAGE_JPEG = "IMAGE_JPEG",
  IMAGE_PNG = "IMAGE_PNG",
  JPEG = "JPEG",
  JPG = "JPG",
  MP4 = "MP4",
  OCTET_STREAM = "OCTET_STREAM",
  PDF = "PDF",
  PNG = "PNG",
  XML = "XML",
}

export enum FileCategory {
  ACCEPTANCE_PROTOCOL = "ACCEPTANCE_PROTOCOL",
  ACCESSORIES = "ACCESSORIES",
  APPOINTMENTS = "APPOINTMENTS",
  BROCHURE = "BROCHURE",
  CE = "CE",
  CERTIFICATES = "CERTIFICATES",
  COMMERCIAL_DATA = "COMMERCIAL_DATA",
  COMPLAINT = "COMPLAINT",
  CONTRACT = "CONTRACT",
  COVERFRAME = "COVERFRAME",
  CUSTOMER_REQUEST = "CUSTOMER_REQUEST",
  DOCUMENTATIONS = "DOCUMENTATIONS",
  DP = "DP",
  ERP = "ERP",
  FC_MANUFACTURING = "FC_MANUFACTURING",
  GENERAL = "GENERAL",
  WARRANTY = "WARRANTY",
  GUARANTEES = "GUARANTEES",
  INSTALLER_REPORT = "INSTALLER_REPORT",
  INSTRUCTION_SHEET = "INSTRUCTION_SHEET",
  LOGO = "LOGO",
  OBJECT = "OBJECT",
  OTHERS = "OTHERS",
  PERFORMANCEDECLARATION = "PERFORMANCEDECLARATION",
  PRODUCT = "PRODUCT",
  PROJECT = "PROJECT",
  RICHTEXT = "RICHTEXT",
  SERVICES = "SERVICES",
  SKETCH = "SKETCH",
  USER = "USER",
  SUSTAINABILITY = "SUSTAINABILITY",
  WIN_DO_PASS_LOGO = "WIN_DO_PASS_LOGO",
}

export enum ErpAddressType {
  DELIVERY = "DELIVERY",
  CUSTOMER = "CUSTOMER",
  CLIENT = "CLIENT",
  ARCHITECT = "ARCHITECT",
  INVOICE = "INVOICE",
}

export enum DocumentationStatus {
  OPEN = "OPEN",
  IN_PROCESS = "IN_PROCESS",
  IN_REVIEW = "IN_REVIEW",
  CLOSED = "CLOSED",
}

export enum DocumentationInputStatus {
  OPEN = "OPEN",
  IN_PROCESS = "IN_PROCESS",
  CLOSED = "CLOSED",
}

export enum ContentCenterCategory {
  GLASS = "GLASS",
  INSECT_SCREEN = "INSECT_SCREEN",
  OTHERS = "OTHERS",
  PLASTIC = "PLASTIC",
  RECYCLING = "RECYCLING",
  ROLLER_SHUTTER = "ROLLER_SHUTTER",
  SERVICE = "SERVICE",
  ABOUT_US = "ABOUT_US",
  OFFICE_HOURS = "OFFICE_HOURS",
}

export enum ContainerType {
  APARTMENT = "APARTMENT",
  BUSINESSAREA = "BUSINESSAREA",
  ROOM = "ROOM",
  BUSINESS = "BUSINESS",
  RESIDENCE = "RESIDENCE",
}

export enum ContactType {
  TENANT = "TENANT",
  CARETAKER = "CARETAKER",
  LANDLORD = "LANDLORD",
  PROPERTY_MANAGER = "PROPERTY_MANAGER",
  PRINCIPAL = "PRINCIPAL",
}

export enum ComponentCategory {
  ACCESSORY = "ACCESSORY",
  ARTICLE = "ARTICLE",
  COMPONENT = "COMPONENT",
  MATERIAL = "MATERIAL",
  SUBCOMPONENT = "SUBCOMPONENT",
}

export enum ClientType {
  ARCHITECT = "ARCHITECT",
  CUSTOMER = "CUSTOMER",
  INSTALLER = "INSTALLER",
  IPS_HOSTER = "IPS_HOSTER",
  RETAILER = "RETAILER",
  WINDOW_BUILDER = "WINDOW_BUILDER",
  SYSTEM_PROVIDER = "SYSTEM_PROVIDER",
}

export enum ClientModuleType {
  ANALYTICS = "ANALYTICS",
  CONTENT_CENTER = "CONTENT_CENTER",
  CONTRACT = "CONTRACT",
  DEMO_SCAN = "DEMO_SCAN",
  FILTER_ALL = "FILTER_ALL",
  FILTER_MY = "FILTER_MY",
  INFO_PORTAL = "INFO_PORTAL",
  MOPLA = "MOPLA",
  PLANNING_TOOL = "PLANNING_TOOL",
  PROJECT_GENERATOR = "PROJECT_GENERATOR",
}

export enum AppointmentType {
  DELIVERY = "DELIVERY",
  INSTALLATION = "INSTALLATION",
  NOT_AVAILABLE = "NOT_AVAILABLE",
  OTHERS = "OTHERS",
  REMAINING_WORK = "REMAINING_WORK",
  SERVICE = "SERVICE",
  SICKNESS = "SICKNESS",
  VACATION = "VACATION",
}

export enum AppointmentStatus {
  RESERVED = "RESERVED",
  PLANNED = "PLANNED",
  PLANABLE = "PLANABLE",
  REQUESTED = "REQUESTED",
  UNPLANNED = "UNPLANNED",
}

export enum AppointmentRequestStatusType {
  NOT_CONFIRMED = "NOT_CONFIRMED",
  CONFIRMED = "CONFIRMED",
  REJECTED = "REJECTED",
}

export enum ActionType {
  CREATE = "CREATE",
  DELETE = "DELETE",
  EDIT = "EDIT",
  GRANT = "GRANT",
  VIEW = "VIEW",
  ACTIVATE = "ACTIVATE",
  DEACTIVATE = "DEACTIVATE",
}

export enum OrderPoolConfigType {
  PROCESS_ID = "PROCESS_ID",
  PROJECT_TITLE = "PROJECT_TITLE",
  ORDER_LINK = "ORDER_LINK",
  ORDER_INTERNAL_STATUS = "ORDER_INTERNAL_STATUS",
  ORDER_STATUS = "ORDER_STATUS",
  ORDER_ACCEPTANCE_STATUS = "ORDER_ACCEPTANCE_STATUS",
  ORDER_TITLE = "ORDER_TITLE",
  ORDER_TOUR_NUMBER = "ORDER_TOUR_NUMBER",
  ORDER_DESCRIPTION = "ORDER_DESCRIPTION",
  ORDER_DELIVERY_ADDRESS = "ORDER_DELIVERY_ADDRESS",
  ORDER_LABEL = "ORDER_LABEL",
  ORDER_RESOURCES = "ORDER_RESOURCES",
  ORDER_PRODUCTION_DATE = "ORDER_PRODUCTION_DATE",
}

export enum ResponseStatus {
  OK = "OK",
  FAIL = "FAIL",
}

export enum ResponseErrorCode {
  INVALID_ACTION = "INVALID_ACTION",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  NO_AUTHORIZATION = "NO_AUTHORIZATION",
  INTERNAL_PLATFORM_ERROR = "INTERNAL_PLATFORM_ERROR",
  CONSULT_SUPPORT = "CONSULT_SUPPORT",
  EMAIL_ALREADY_EXISTS = "EMAIL_ALREADY_EXISTS",
  INVALID_PASSWORD = "INVALID_PASSWORD",
  CODE_INVALID_OR_USER_ALREADY_ACTIVATED = "CODE_INVALID_OR_USER_ALREADY_ACTIVATED",
}

export enum HttpStatusCode {
  Value100Continue = "100 Continue",
  Value101SwitchingProtocols = "101 Switching Protocols",
  Value102Processing = "102 Processing",
  Value103EarlyHints = "103 Early Hints",
  Value200OK = "200 OK",
  Value201Created = "201 Created",
  Value202Accepted = "202 Accepted",
  Value203NonAuthoritativeInformation = "203 Non-Authoritative Information",
  Value204NoContent = "204 No Content",
  Value205ResetContent = "205 Reset Content",
  Value206PartialContent = "206 Partial Content",
  Value207MultiStatus = "207 Multi-Status",
  Value208AlreadyReported = "208 Already Reported",
  Value226IMUsed = "226 IM Used",
  Value300MultipleChoice = "300 Multiple Choice",
  Value301MovedPermanently = "301 Moved Permanently",
  Value302Found = "302 Found",
  Value303SeeOther = "303 See Other",
  Value304NotModified = "304 Not Modified",
  Value305UseProxy = "305 Use Proxy",
  Value307TemporaryRedirect = "307 Temporary Redirect",
  Value308PermanentRedirect = "308 Permanent Redirect",
  Value400BadRequest = "400 Bad Request",
  Value401Unauthorized = "401 Unauthorized",
  Value402PaymentRequired = "402 Payment Required",
  Value403Forbidden = "403 Forbidden",
  Value404NotFound = "404 Not Found",
  Value405MethodNotAllowed = "405 Method Not Allowed",
  Value406NotAcceptable = "406 Not Acceptable",
  Value407ProxyAuthenticationRequired = "407 Proxy Authentication Required",
  Value408RequestTimeout = "408 Request Timeout",
  Value409Conflict = "409 Conflict",
  Value410Gone = "410 Gone",
  Value411LengthRequired = "411 Length Required",
  Value412PreconditionFailed = "412 Precondition Failed",
  Value413PayloadTooLarge = "413 Payload Too Large",
  Value414URITooLong = "414 URI Too Long",
  Value415UnsupportedMediaType = "415 Unsupported Media Type",
  Value416RangeNotSatisfiable = "416 Range Not Satisfiable",
  Value417ExpectationFailed = "417 Expectation Failed",
  Value421MisdirectedRequest = "421 Misdirected Request",
  Value422UnprocessableEntity = "422 Unprocessable Entity",
  Value423Locked = "423 Locked",
  Value424FailedDependency = "424 Failed Dependency",
  Value425TooEarly = "425 Too Early",
  Value426UpgradeRequired = "426 Upgrade Required",
  Value428PreconditionRequired = "428 Precondition Required",
  Value429TooManyRequests = "429 Too Many Requests",
  Value431RequestHeaderFieldsTooLarge = "431 Request Header Fields Too Large",
  Value451UnavailableForLegalReasons = "451 Unavailable For Legal Reasons",
  Value500InternalServerError = "500 Internal Server Error",
  Value501NotImplemented = "501 Not Implemented",
  Value502BadGateway = "502 Bad Gateway",
  Value503ServiceUnavailable = "503 Service Unavailable",
  Value504GatewayTimeout = "504 Gateway Timeout",
  Value505HTTPVersionNotSupported = "505 HTTP Version Not Supported",
  Value506VariantAlsoNegotiates = "506 Variant Also Negotiates",
  Value507InsufficientStorage = "507 Insufficient Storage",
  Value508LoopDetected = "508 Loop Detected",
  Value510NotExtended = "510 Not Extended",
  Value511NetworkAuthenticationRequired = "511 Network Authentication Required",
}

export enum ApiStatus {
  AVAILABLE = "AVAILABLE",
  UNAVAILABLE = "UNAVAILABLE",
}

export interface ApiStatusDto {
  name?: string;
  endpoint?: string;
  status?: ApiStatus;
}

export interface WinDoFlowResponseListApiStatusDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: ApiStatusDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface DefaultWinDoFlowResponse {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: object;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface OrderPoolConfigDto {
  type: OrderPoolConfigType;
  /** @format int32 */
  ranking: number;
}

export interface AclClientModuleView {
  clientGuid?: string;
  client?: ClientView;
  type_Id?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  sid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface AclUserEntityView {
  clientType_Value?: string;
  actionType_Value?: string;
  user?: UserView;
  guid?: string;
  instanceType_Id?: string;
  instanceType_Value?: string;
  userGuid?: string;
  instanceType?: InstanceType;
  clientType_Id?: string;
  actionType_Id?: string;
  actionType?: ActionType;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface AddressView {
  type?: ErpAddressType;
  region?: string;
  description?: string;
  firstname?: string;
  lastname?: string;
  type_Id?: string;
  guid?: string;
  email?: string;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  type_Value?: string;
  salutationValue?: string;
  country_Id?: string;
  klaesId?: string;
  street?: string;
  zip?: string;
  city?: string;
  phone?: string;
  houseNumber?: string;
  country_Value?: string;
  salutationId?: string;
  remark?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface Annotation {
  valueType?: ValueType;
  value?: object;
  type?: string;
  term?: string;
  primitive?: boolean;
  enum?: boolean;
  null?: boolean;
  geospatial?: boolean;
  collection?: boolean;
  complex?: boolean;
}

export interface AppointmentClientMappingView {
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  clientGuid?: string;
  guid?: string;
  appointment?: AppointmentView;
  requestStatus?: AppointmentRequestStatusType;
  appointmentGuid?: string;
  requiredModules?: ClientModuleType[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface AppointmentInstanceActionView {
  instanceType?: InstanceType;
  permission?: AppointmentPermissionView;
  appointment?: AppointmentView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface AppointmentOrderLineMappingView {
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  orderLineGuid?: string;
  appointment?: AppointmentView;
  appointmentGuid?: string;
  requiredModules?: ClientModuleType[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface AppointmentPermissionActionView {
  instanceType?: InstanceType;
  permission?: AppointmentPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface AppointmentPermissionView {
  instanceType?: InstanceType;
  actions?: AppointmentPermissionActionView[];
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface AppointmentResourceMappingView {
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  guid?: string;
  resourceGuid?: string;
  status_Id?: string;
  appointment?: AppointmentView;
  status_Value?: string;
  resourceTitle?: string;
  appointmentGuid?: string;
  requiredModules?: ClientModuleType[];
  resourceCategory_Id?: string;
  resourceDescription?: string;
  resourceCategory_Value?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface AppointmentTeamMappingView {
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  guid?: string;
  teamGuid?: string;
  appointment?: AppointmentView;
  appointmentGuid?: string;
  requiredModules?: ClientModuleType[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface AppointmentUserMappingView {
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  guid?: string;
  userGuid?: string;
  appointment?: AppointmentView;
  appointmentGuid?: string;
  requiredModules?: ClientModuleType[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface AppointmentView {
  resources?: ResourceView[];
  actions?: AppointmentInstanceActionView[];
  type?: AppointmentType;
  order?: OrderView;
  description?: string;
  status?: AppointmentStatus;
  /** @format date-time */
  start?: string;
  /** @format date-time */
  createdOn?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  /** @format date-time */
  end?: string;
  type_Id?: string;
  guid?: string;
  users?: UserView[];
  orderLines?: OrderLineView[];
  orderAcceptanceStatus_Value?: string;
  status_Id?: string;
  type_Value?: string;
  issuedToUserGuid?: string;
  clients?: ClientView[];
  status_Value?: string;
  permissionActions?: BasePermissionActionView[];
  klaesId?: string;
  title?: string;
  orderId?: string;
  teams?: TeamView[];
  orderGuid?: string;
  appointmentGuid?: string;
  userMappings?: AppointmentUserMappingView[];
  orderCity?: string;
  orderStreet?: string;
  orderCountry_Id?: string;
  teamMappings?: AppointmentTeamMappingView[];
  clientMappings?: AppointmentClientMappingView[];
  orderType_Value?: string;
  orderZip?: string;
  teamGuids?: string;
  requiredModules?: ClientModuleType[];
  orderDescription?: string;
  createdBy_UserGuid?: string;
  orderStatus_Value?: string;
  projectProcessId?: string;
  orderHouseNumber?: string;
  resourceMappings?: AppointmentResourceMappingView[];
  orderCountry_Value?: string;
  createdBy_ClientTitle?: string;
  updatedBy_UserFullname?: string;
  createdBy_UserFullname?: string;
  appointmentSeriesGuid?: string;
  orderLineMappings?: AppointmentOrderLineMappingView[];
  updatedBy_ClientTitle?: string;
  orderInternalStatusText?: string;
  orderTitle?: string;
  createdBy_ClientGuid?: string;
}

export interface BasePermissionActionView {
  instanceType?: InstanceType;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  createdBy_ClientGuid?: string;
}

export interface ClientConfigurationView {
  value?: string;
  key?: string;
  /** @format int32 */
  counter?: number;
  /** @format int32 */
  isActive?: number;
  /** @format date-time */
  createdOn?: string;
  /** @format int32 */
  isDeleted?: number;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  client?: ClientView;
  type_Id?: string;
  configurationDescription?: string;
  type_Value?: string;
  configurationTitle?: string;
  configurationImageName?: string;
  applicationId?: string;
  configurationId?: string;
  sid?: string;
  applicationDescription?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ClientInstanceActionView {
  instanceType?: InstanceType;
  permission?: ClientPermissionView;
  client?: ClientView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ClientPartnerView {
  client?: ClientView;
  type_Id?: string;
  partnerGuid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  title?: string;
  sid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ClientPermissionActionView {
  instanceType?: InstanceType;
  permission?: ClientPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ClientPermissionView {
  instanceType?: InstanceType;
  actions?: ClientPermissionActionView[];
  client?: ClientView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface ClientView {
  logoDetail?: FileView;
  permissions?: ClientPermissionView[];
  actions?: ClientInstanceActionView[];
  type?: ClientType;
  address?: AddressView;
  isActive?: boolean;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  telephone?: string;
  addressGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  users?: UserView[];
  email?: string;
  fileMappings?: FileMappingView[];
  dealerModuleId?: string;
  klaesCompany?: string;
  klaesMandant?: string;
  klaesEmail?: string;
  klaesPassword?: string;
  type_Value?: string;
  activationChangedBy?: string;
  /** @format date-time */
  activationChangedOn?: string;
  invitedByPartnerService?: boolean;
  invitedBy_ClientGuid?: string;
  orders?: OrderView[];
  forms?: FormView[];
  contactPersonTelephone?: string;
  contactPersonEmail?: string;
  informationLink?: string;
  logoFileGuid?: string;
  partnerData?: PartnerDataView[];
  appointments?: AppointmentView[];
  supportLink?: string;
  subscriptions?: SubscriptionView[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  files?: FileView[];
  website?: string;
  street?: string;
  zip?: string;
  city?: string;
  title?: string;
  contactPerson?: string;
  orderDetails?: OrderView[];
  erpTokens?: ERPTokenView[];
  addressDetail?: Entity;
  projects?: InstancePartnerProjectView[];
  partners?: ClientPartnerView[];
  winDoPassAgreementAccepted?: boolean;
  clientConfigurations?: ClientConfigurationView[];
  aclClientModules?: AclClientModuleView[];
  contentCenterViews?: ContentCenterView[];
}

export interface ComponentComponentLabelMappingView {
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  component?: ComponentView;
  guid?: string;
  componentGuid?: string;
  componentLabel?: ComponentLabelView;
  componentLabelGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ComponentInstanceActionView {
  instanceType?: InstanceType;
  permission?: ComponentPermissionView;
  component?: ComponentView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ComponentLabelView {
  text?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  fileViews?: FileView[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ComponentLanguageView {
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  language_Value?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  component?: ComponentView;
  guid?: string;
  note?: string;
  /** @format int32 */
  isDefault?: number;
  customerText?: string;
  textShort?: string;
  textLong?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  createdBy_ClientGuid?: string;
  files?: FileView[];
  title?: string;
  /** @format int32 */
  translationCount?: number;
  createdBy_UserGuid?: string;
  issuedToClientTitle?: string;
  createdBy_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface ComponentPermissionActionView {
  instanceType?: InstanceType;
  permission?: ComponentPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ComponentPermissionView {
  instanceType?: InstanceType;
  actions?: ComponentPermissionActionView[];
  component?: ComponentView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface ComponentView {
  /** @format double */
  height?: number;
  permissions?: ComponentPermissionView[];
  actions?: ComponentInstanceActionView[];
  product?: ProductView;
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  /** @format double */
  width?: number;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  component?: ComponentView;
  guid?: string;
  note?: string;
  erpdocumentGuid?: string;
  quantity?: number;
  componentGuid?: string;
  orderLines?: OrderLineView[];
  templateGuid?: string;
  category?: ComponentCategory;
  projectGuid?: string;
  fileMappings?: FileMappingView[];
  /** @format int32 */
  isDemand?: number;
  weightUOM_Value?: string;
  customerText?: string;
  /** @format int32 */
  isAddition?: number;
  textShort?: string;
  /** @format int32 */
  isInternal?: number;
  currency_Id?: string;
  measurementUom?: UomMetreType;
  netPrice?: number;
  quantityUOM_Id?: string;
  /** @format int32 */
  isTemplate?: number;
  /** @format int32 */
  isAlternative?: number;
  weightUOM_Id?: string;
  currency_Value?: string;
  textLong?: string;
  category_Id?: string;
  project?: ProjectView;
  weight?: number;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  productGuid?: string;
  subComponents?: ComponentView[];
  erpdocumentLine?: ERPDocumentLineView;
  erpdocument?: ERPDocumentView;
  erpdocumentLineGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  files?: FileView[];
  title?: string;
  category_Value?: string;
  erpuploadId?: string;
  orderId?: string;
  notes?: NoteView[];
  componentLabelMappings?: ComponentComponentLabelMappingView[];
  /** @format int32 */
  translationCount?: number;
  componentLanguages?: ComponentLanguageView[];
  quantityUOM_Value?: string;
  createdBy_UserGuid?: string;
  issuedToClientTitle?: string;
  createdBy_UserFullname?: string;
}

export interface ContactInstanceActionView {
  instanceType?: InstanceType;
  permission?: ContactPermissionView;
  contact?: ContactView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ContactPartnerView {
  contact?: ContactView;
  type_Id?: string;
  partnerGuid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  title?: string;
  sid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ContactPermissionActionView {
  instanceType?: InstanceType;
  permission?: ContactPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ContactPermissionView {
  instanceType?: InstanceType;
  actions?: ContactPermissionActionView[];
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface ContactView {
  actions?: ContactInstanceActionView[];
  type?: ContactType;
  order?: OrderView;
  country?: string;
  region?: string;
  description?: string;
  /** @format date-time */
  createdOn?: string;
  firstname?: string;
  telephone?: string;
  lastname?: string;
  salutation_Id?: string;
  /** @format date-time */
  updatedOn?: string;
  mobile?: string;
  guid?: string;
  fax?: string;
  instanceType_Id?: string;
  salutation_Value?: string;
  containers?: ContainerView[];
  email?: string;
  addressTitle?: string;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  designation?: string;
  imageGuid?: string;
  contactType_Id?: string;
  project?: ProjectView;
  instanceType_Value?: string;
  languageValue?: string;
  languageId?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  country_Id?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  street?: string;
  zip?: string;
  city?: string;
  company?: string;
  houseNumber?: string;
  addressDescription?: string;
  country_Value?: string;
  partners?: ContactPartnerView[];
  place?: string;
  contactType_Value?: string;
  /** @format int32 */
  useContainerAddress?: number;
  issuedToClientTitle?: string;
}

export interface ContainerInstanceActionView {
  instanceType?: InstanceType;
  permission?: ContainerPermissionView;
  container?: ContainerView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ContainerPartnerView {
  container?: ContainerView;
  type_Id?: string;
  partnerGuid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  title?: string;
  sid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ContainerPermissionActionView {
  instanceType?: InstanceType;
  permission?: ContainerPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ContainerPermissionView {
  instanceType?: InstanceType;
  actions?: ContainerPermissionActionView[];
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface ContainerView {
  actions?: ContainerInstanceActionView[];
  description?: string;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  partnerGuid?: string;
  containerGuid?: string;
  contactGuid?: string;
  /** @format int32 */
  isRentable?: number;
  /** @format int32 */
  isRented?: number;
  imageGuid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  documentations?: DocumentationView[];
  contacts?: ContactView[];
  permissionActions?: BasePermissionActionView[];
  title?: string;
  partners?: ContainerPartnerView[];
  issuedToClientTitle?: string;
  createdBy_ClientGuid?: string;
}

export interface ContentCenterTextView {
  language?: Language;
  description?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  languageValue?: string;
  languageId?: string;
  contentCenterGuid?: string;
  contentCenterView?: ContentCenterView;
  title?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ContentCenterView {
  description?: string;
  /** @format date-time */
  validFrom?: string;
  isActive?: boolean;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  validTill?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  category?: ContentCenterCategory;
  fileViews?: FileView[];
  contentCenterTextViews?: ContentCenterTextView[];
  title?: string;
  categoryValue?: string;
  categoryId?: string;
  clientView?: ClientView;
  createdByUserFullName?: string;
  updatedByUserFullName?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface DocumentationDto {
  inputOfflineMappings?: DocumentationInputOfflineMappingDto[];
  description?: string;
  createdOn?: string;
  guid?: string;
  orderLineGuid?: string;
  formClientGuid?: string;
  /** @format int32 */
  isServerManaged?: number;
  productGuid?: string;
  assignedTo?: string;
  assignedOn?: string;
  status_Value?: string;
  formType_Value?: string;
  formGuid?: string;
  formType?: FormType;
  documentationInputDetails?: DocumentationInputDto[];
  orderGuid?: string;
  orderLineDetails?: OrderLineView[];
}

export interface DocumentationInputDto {
  value?: string;
  createdOn?: string;
  guid?: string;
  formInputGuid?: string;
  /** @format int32 */
  isMandatory?: number;
  status_Value?: string;
  formGuid?: string;
  formInputDetailGuid?: string;
}

export interface DocumentationInputOfflineMappingDto {
  guid?: string;
  offlineGuid?: string;
}

export interface DocumentationInputView {
  value?: string;
  /** @format int32 */
  counter?: number;
  status?: DocumentationInputStatus;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  /** @format date-time */
  plannedOn?: string;
  closedBy?: string;
  plannedBy?: string;
  formInputGuid?: string;
  /** @format int32 */
  isMandatory?: number;
  parentId?: string;
  documentation?: DocumentationView;
  formInputDetailDefaultValue?: string;
  formInputDetailDescription?: string;
  fileGuid?: string;
  /** @format date-time */
  closedOn?: string;
  status_Id?: string;
  /** @format date-time */
  checkedOn?: string;
  checkedBy?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  documentationGuid?: string;
  formInputType?: FormInputType;
  status_Value?: string;
  files?: FileView[];
  formGuid?: string;
  childrens?: DocumentationInputView[];
  formInputParentId?: string;
  /** @format int32 */
  formInputForAcceptance?: number;
  /** @format int32 */
  formInputDetailPosition?: number;
  /** @format int32 */
  formInputPosition?: number;
  formInputClientGuid?: string;
  /** @format int32 */
  formInputIsMandatory?: number;
  formInputDetailGuid?: string;
  formInputDescription?: string;
  documentationParentId?: string;
  documentationParentGuid?: string;
  formInputType_Value?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface DocumentationInstanceActionView {
  instanceType?: InstanceType;
  permission?: DocumentationPermissionView;
  documentation?: DocumentationView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface DocumentationMappingView {
  guid?: string;
  instanceType_Id?: string;
  documentation?: DocumentationView;
  instanceType_Value?: string;
  documentationGuid?: string;
  instanceGuid?: string;
  orderLine?: OrderLineView;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface DocumentationPartnerView {
  documentation?: DocumentationView;
  type_Id?: string;
  partnerGuid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  title?: string;
  sid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface DocumentationPermissionActionView {
  instanceType?: InstanceType;
  permission?: DocumentationPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface DocumentationPermissionView {
  instanceType?: InstanceType;
  actions?: DocumentationPermissionActionView[];
  documentation?: DocumentationView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface DocumentationSignatureView {
  type?: SignatureType;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  typeValue?: string;
  isRequired?: boolean;
  documentationGuid?: string;
  typeId?: string;
  documentationView?: DocumentationView;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface DocumentationView {
  formView?: FormView;
  permissions?: DocumentationPermissionView[];
  actions?: DocumentationInstanceActionView[];
  order?: OrderView;
  description?: string;
  status?: DocumentationStatus;
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  /** @format date-time */
  plannedOn?: string;
  closedBy?: string;
  plannedBy?: string;
  assignedBy?: string;
  containers?: ContainerView[];
  documentationSignatureViews?: DocumentationSignatureView[];
  /** @format date-time */
  closedOn?: string;
  status_Id?: string;
  containerGuid?: string;
  formCategory?: FormCategory;
  clientGuidTo?: string;
  installerReport?: boolean;
  clientGuidFrom?: string;
  /** @format date-time */
  checkedOn?: string;
  checkedBy?: string;
  orderLineGuid?: string;
  formDescription?: string;
  formClientGuid?: string;
  /** @format int32 */
  isServerManaged?: number;
  formObjectType_Value?: string;
  formVisibility_Value?: string;
  acceptanceProtocol?: boolean;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  assignedBy_UserFullname?: string;
  productGuid?: string;
  assignedTo?: string;
  /** @format date-time */
  assignedOn?: string;
  status_Value?: string;
  formType_Value?: string;
  documentationInputs?: DocumentationInputView[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  files?: FileView[];
  formGuid?: string;
  formType?: FormType;
  formType_Id?: string;
  orderId?: string;
  signatureRequired?: boolean;
  orderGuid?: string;
  closedByUser?: UserView;
  causedOrders?: OrderView[];
  formCategory_Id?: string;
  projects?: ProjectView[];
  partners?: DocumentationPartnerView[];
  notes?: NoteView[];
  tagId?: string;
  formContainerType_Value?: string;
  formTemplateGuid?: string;
  createdBy_UserGuid?: string;
  checked?: boolean;
  issuedToClientTitle?: string;
  createdBy_ClientTitle?: string;
  orderLineDetails?: EntityCollection;
  formCategory_Value?: string;
  assignedTo_UserFullname?: string;
  orderTitle?: string;
  orderLineTitle?: string;
  projectTitle?: string;
}

export interface ERPAddressDeliveryView {
  agent01?: string;
  agent04?: string;
  agent03?: string;
  agent02?: string;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  firstname?: string;
  telephone?: string;
  lastname?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  fax?: string;
  email?: string;
  clientId?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  erpdocument?: ERPDocumentView;
  instanceGuid?: string;
  street?: string;
  zip?: string;
  city?: string;
  country_Value?: string;
  referenceGuid?: string;
  salutationText?: string;
  housenumber?: string;
  address02?: string;
  countryText?: string;
  address01?: string;
  orderId?: string;
  clientIdInternal?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ERPAddressView {
  agent01?: string;
  agent04?: string;
  agent03?: string;
  agent02?: string;
  empty?: boolean;
  type?: ErpAddressType;
  region?: string;
  description?: string;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  firstname?: string;
  telephone?: string;
  lastname?: string;
  salutation_Id?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  fax?: string;
  salutation_Value?: string;
  email?: string;
  clientId?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  erpdocument?: ERPDocumentView;
  instanceGuid?: string;
  country_Id?: string;
  street?: string;
  zip?: string;
  city?: string;
  country_Value?: string;
  referenceGuid?: string;
  salutationText?: string;
  housenumber?: string;
  languageText?: string;
  address02?: string;
  countryText?: string;
  address01?: string;
  orderId?: string;
  remark?: string;
  issuedToClientTitle?: string;
  clientIdInternal?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ERPAppointmentView {
  description?: string;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  erpdocument?: ERPDocumentView;
  instanceGuid?: string;
  referenceGuid?: string;
  orderId?: string;
  appointmentWeek?: string;
  /** @format date-time */
  appointmentDate?: string;
  issuedToClientTitle?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ERPCasementView {
  /** @format double */
  height?: number;
  type?: string;
  /** @format double */
  width?: number;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  erpglasses?: ERPGlassView[];
  erpfittings?: ERPFittingView[];
  instanceGuid?: string;
  handlePositionText?: string;
  fittingParameter?: string;
  gasketStopShortText?: string;
  gasketStopLongText?: string;
  casementIdDrawing?: string;
  elementId?: string;
  referenceGuid?: string;
  documentLineId?: string;
  erpcoverFrame?: ERPCoverFrameView;
  orderId?: string;
  handlePosition_Value?: string;
  typeValueAlu?: string;
  design_Value?: string;
  designValueAlu?: string;
  designExterior_Text?: string;
  designInterior_Value?: string;
  designExterior_Value?: string;
  designInterior_Text?: string;
  issuedToClientTitle?: string;
  type_Text?: string;
  typeTextAlu?: string;
  designTextAlu?: string;
  design_Text?: string;
  casementId?: string;
  groupNumber?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ERPCoverFrameView {
  /** @format double */
  height?: number;
  type?: string;
  /** @format double */
  width?: number;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  erpdocumentLine?: ERPDocumentLineView;
  erpcasements?: ERPCasementView[];
  erpfittings?: ERPFittingView[];
  products?: ProductView[];
  instanceGuid?: string;
  elementId?: string;
  referenceGuid?: string;
  documentLineId?: string;
  orderId?: string;
  typeValueAlu?: string;
  design_Value?: string;
  designValueAlu?: string;
  designExterior_Text?: string;
  designInterior_Value?: string;
  designExterior_Value?: string;
  designInterior_Text?: string;
  issuedToClientTitle?: string;
  type_Text?: string;
  typeTextAlu?: string;
  designTextAlu?: string;
  design_Text?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ERPDocumentLineView {
  /** @format double */
  height?: number;
  /** @format int32 */
  service?: number;
  description?: string;
  /** @format double */
  width?: number;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  condition?: string;
  guid?: string;
  note?: string;
  deliveryRemark?: string;
  /** @format date-time */
  deliveryDate?: string;
  versionValueAlu?: string;
  /** @format double */
  quantity?: number;
  deliveryWeek?: string;
  versionTextAlu?: string;
  unit?: string;
  shutterJalousieSystem_Text?: string;
  insectProtectionSystem_Value?: string;
  shutterHandlingSystem_Text?: string;
  shutterHandlingSystem_Value?: string;
  insectProtectionSystem_Text?: string;
  shutterJalousieSystem_Value?: string;
  customerText?: string;
  netPrice?: number;
  /** @format double */
  weight?: number;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  erpcoverFrames?: ERPCoverFrameView[];
  products?: ProductView[];
  erpdocument?: ERPDocumentView;
  instanceGuid?: string;
  gasketSystem_Value?: string;
  gasketSystem_Text?: string;
  versionGasket_Text?: string;
  versionGasket_Value?: string;
  shutterSystem_Text?: string;
  shutterSystem_Value?: string;
  fittingGroup_Value?: string;
  drainageSystem_Value?: string;
  positionInstallationCW?: string;
  dowelSystem_Text?: string;
  glasPriceList_Value?: string;
  shutterBoxSystem_Text?: string;
  shutterBoxSystem_Value?: string;
  dowelSystem_Value?: string;
  drainageSystem_Text?: string;
  typeTextLong?: string;
  typeText?: string;
  lineId_Text?: string;
  referenceGuid?: string;
  architect_Text?: string;
  documentLineId?: string;
  erptimes?: ERPTimeView[];
  pdfFileGuid?: string;
  version_Text?: string;
  productNo_Text?: string;
  version_Value?: string;
  lineId_Value?: string;
  ceMarking_Text?: string;
  sketchFileGuid?: string;
  productNo_Value?: string;
  woodType_Value?: string;
  colorNo_Text?: string;
  colorNo_Value?: string;
  ceMarking_Value?: string;
  orderId?: string;
  uwert?: number;
  /** @format double */
  amount?: number;
  memo?: string;
  productDescription?: string;
  fittingGroup_Text?: string;
  gasketColor_Value?: string;
  baseBodyColor_Value?: string;
  profileGroup_Text?: string;
  baseBodyColor_Text?: string;
  gasketColor_Text?: string;
  remark?: string;
  issuedToClientTitle?: string;
  clientItemNo?: string;
  profileGroup?: string;
  woodType_Text?: string;
  purchaseRemark?: string;
  division?: string;
  kindText?: string;
  orderLineTitle?: string;
  buildNumbers?: string;
  guaranteeId?: string;
  productName?: string;
  /** @format int32 */
  foldLamination?: number;
  positionInstallationRemark?: string;
  /** @format date-time */
  positionInstallationDate?: string;
  glasPriceList_Text?: string;
  profileGroup_Value?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ERPDocumentView {
  processId?: string;
  erpaddressDeliveries?: ERPAddressDeliveryView[];
  /** @format int32 */
  unassignedProductsCount?: number;
  erpdocumentLines?: ERPDocumentLineView[];
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  tourNumber?: string;
  /** @format date-time */
  productionDate?: string;
  factoryId?: string;
  /** @format int32 */
  unassignedComponentsCount?: number;
  clientId?: string;
  partnerGuid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  title?: string;
  referenceGuid?: string;
  orderType?: OrderType;
  pdfFileGuid?: string;
  creatorId?: string;
  languageText?: string;
  editorText?: string;
  erpappointments?: ERPAppointmentView[];
  orderTypeValue?: string;
  editorId?: string;
  /** @format date-time */
  deliveryOn?: string;
  erpaddresses?: ERPAddressView[];
  clientName?: string;
  orderId?: string;
  memo?: string;
  projectDescription?: string;
  remark?: string;
  issuedToClientTitle?: string;
  purchaseRemark?: string;
  creatorText?: string;
  projectTitle?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ERPFittingView {
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  manufacturer_Value?: string;
  manufacturerText?: string;
  sortingIndicator?: string;
  length2UOM_Value?: UomMetreType;
  length1UOM_Value?: UomMetreType;
  articleType_Value?: string;
  elementId?: string;
  typeText?: string;
  referenceGuid?: string;
  documentLineId?: string;
  erpcoverFrame?: ERPCoverFrameView;
  length2UOM_Id?: string;
  length1UOM_Id?: string;
  articleType_Id?: string;
  manufacturer_Id?: string;
  orderId?: string;
  length2?: number;
  length1?: number;
  erpcasement?: ERPCasementView;
  issuedToClientTitle?: string;
  casementId?: string;
  orderNumber?: string;
  articleTypeText?: string;
  fittingId?: string;
  orderNumberText?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ERPGlassView {
  /** @format double */
  height?: number;
  /** @format double */
  depth?: number;
  description?: string;
  /** @format double */
  width?: number;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  elementId?: string;
  referenceGuid?: string;
  documentLineId?: string;
  glasIdDrawing?: string;
  orderId?: string;
  glasId?: string;
  erpcasement?: ERPCasementView;
  specialGlass01?: string;
  casementId?: string;
  longText?: string;
  salesText?: string;
  specialGlass02?: string;
  shortText?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ERPTimeView {
  guid?: string;
  erpdocumentLine?: ERPDocumentLineView;
  /** @format int32 */
  workstationNumber?: number;
  costCenterNumber?: string;
  costCenterText?: string;
  referenceGuid?: string;
  workstation?: string;
  /** @format double */
  hourlyRate?: number;
  /** @format double */
  presentMinutes?: number;
  /** @format date-time */
  sys_DeletedOn?: string;
  /** @format int32 */
  sys_IsDeleted?: number;
  sys_DeletedBy?: string;
  timeId?: string;
  /** @format double */
  workers?: number;
  /** @format date-time */
  sys_UpdatedOn?: string;
  sys_CreatedBy?: string;
  /** @format date-time */
  sys_CreatedOn?: string;
  sys_UpdatedBy?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ERPTokenView {
  token?: string;
  clientGuid?: string;
  client?: ClientView;
  guid?: string;
  userGuid?: string;
  /** @format date-time */
  sys_UpdatedOn?: string;
  sys_CreatedBy?: string;
  /** @format date-time */
  sys_CreatedOn?: string;
  sys_UpdatedBy?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface Entity {
  annotations?: Annotation[];
  /** @format uri */
  baseURI?: string;
  /** @format uri */
  id?: string;
  title?: string;
  associationLinks?: Link[];
  navigationLinks?: Link[];
  type?: string;
  editLink?: Link;
  mediaEditLinks?: Link[];
  operations?: Operation[];
  properties?: Property[];
  /** @format uri */
  mediaContentSource?: string;
  mediaContentType?: string;
  mediaETag?: string;
  etag?: string;
  selfLink?: Link;
  mediaEntity?: boolean;
  navigationBindings?: Link[];
}

export interface EntityCollection {
  annotations?: Annotation[];
  /** @format uri */
  baseURI?: string;
  /** @format uri */
  id?: string;
  title?: string;
  entities?: Entity[];
  /** @format int32 */
  count?: number;
  /** @format uri */
  next?: string;
  /** @format uri */
  deltaLink?: string;
  operations?: Operation[];
}

export interface FileInstanceActionView {
  instanceType?: InstanceType;
  file?: FileView;
  permission?: FilePermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface FileMappingView {
  order?: OrderView;
  product?: ProductView;
  component?: ComponentView;
  client?: ClientView;
  guid?: string;
  note?: NoteView;
  instanceType_Id?: string;
  documentation?: DocumentationView;
  fileGuid?: string;
  project?: ProjectView;
  instanceType_Value?: string;
  instanceGuid?: string;
  instanceType?: InstanceType;
  contentCenterView?: ContentCenterView;
  klaesId?: string;
  valueHelp?: ValueHelpView;
  fileView?: FileView;
  productLabel?: ProductLabelView;
  componentLabel?: ComponentLabelView;
  orderLine?: OrderLineView;
  contentCenterText?: ContentCenterTextView;
  documentationInput?: DocumentationInputView;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface FilePermissionActionView {
  instanceType?: InstanceType;
  permission?: FilePermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface FilePermissionView {
  instanceType?: InstanceType;
  actions?: FilePermissionActionView[];
  file?: FileView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface FileView {
  instanceGuid?: string;
  name?: string;
  /** @format int32 */
  bytes?: number;
  permissions?: FilePermissionView[];
  actions?: FileInstanceActionView[];
  type?: FileType;
  description?: string;
  systemId?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  mimeType?: string;
  fileUrl?: string;
  category?: FileCategory;
  fileMappings?: FileMappingView[];
  category_Id?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  klaesId?: string;
  category_Value?: string;
  /** @format int32 */
  isStored?: number;
  isTrustedSource?: boolean;
  previewable?: boolean;
  /** @format date-time */
  changedOn?: string;
  source_Value?: string;
  source_Id?: string;
  createdBy_UserFullname?: string;
  /** @format int32 */
  isSystemFileCategory?: number;
}

export interface FormFormTypeView {
  form?: FormView;
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  formType_Value?: string;
  createdBy_ClientGuid?: string;
  formGuid?: string;
  formType_Id?: string;
  formType?: FormType;
  createdBy_UserGuid?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface FormInputLanguageView {
  description?: string;
  /** @format int32 */
  position?: number;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  /** @format int32 */
  isMandatory?: number;
  parentId?: string;
  type_Value?: string;
  instanceGuid?: string;
  title?: string;
  formGuid?: string;
  formInput?: FormInputView;
  variantGuid?: string;
  sid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface FormInputPropLanguageView {
  defaultValue?: string;
  description?: string;
  /** @format int32 */
  position?: number;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  formInputGuid?: string;
  instanceGuid?: string;
  title?: string;
  variantGuid?: string;
  formInputProp?: FormInputPropView;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface FormInputPropView {
  defaultValue?: string;
  description?: string;
  /** @format int32 */
  position?: number;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  formInputGuid?: string;
  instanceGuid?: string;
  title?: string;
  formInput?: FormInputView;
  variantGuid?: string;
  formInputPropLanguages?: FormInputPropLanguageView[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface FormInputView {
  parent?: FormInputView;
  type?: FormInputType;
  form?: FormView;
  children?: FormInputView[];
  description?: string;
  /** @format int32 */
  position?: number;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  /** @format int32 */
  forAcceptance?: number;
  /** @format int32 */
  isMandatory?: number;
  parentId?: string;
  type_Value?: string;
  instanceGuid?: string;
  title?: string;
  formGuid?: string;
  /** @format date-time */
  sys_DeletedOn?: string;
  parentSid?: string;
  /** @format int32 */
  sys_IsDeleted?: number;
  formInputProps?: FormInputPropView[];
  sys_DeletedBy?: string;
  variantGuid?: string;
  objectType_Id?: string;
  isUsedInternally?: boolean;
  productCategory_Value?: string;
  isUsedExternally?: boolean;
  sid?: string;
  objectType_Value?: string;
  productCategory_Id?: string;
  formInputLanguages?: FormInputLanguageView[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface FormLanguageView {
  form?: FormView;
  description?: string;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  templateGuid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  title?: string;
  containerType_Id?: string;
  containerType_Value?: string;
  variantGuid?: string;
  issuedToClientTitle?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface FormProductCategoryView {
  form?: FormView;
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  createdBy_ClientGuid?: string;
  formGuid?: string;
  productCategory?: ProductCategory;
  productCategory_Value?: string;
  createdBy_UserGuid?: string;
  productCategory_Id?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface FormSignatureView {
  type?: SignatureType;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  typeValue?: string;
  isRequired?: boolean;
  formGuid?: string;
  formView?: FormView;
  typeId?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface FormView {
  type?: FormType;
  description?: string;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  client?: ClientView;
  type_Id?: string;
  guid?: string;
  templateGuid?: string;
  formInputs?: FormInputView[];
  isUsedForOrder?: boolean;
  category?: FormCategory;
  category_Id?: string;
  type_Value?: string;
  instanceGuid?: string;
  title?: string;
  containerType_Id?: string;
  containerType_Value?: string;
  category_Value?: string;
  variantGuid?: string;
  formFormTypes?: FormFormTypeView[];
  formLanguages?: FormLanguageView[];
  isUsedForOrderLine?: boolean;
  signatureRequired?: boolean;
  validForCurrentUser?: boolean;
  parentFormInputs?: FormInputView[];
  formSignatureViews?: FormSignatureView[];
  formProductCategories?: FormProductCategoryView[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface InstancePartnerProjectView {
  description?: string;
  partnerGuid?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  title?: string;
  sid?: string;
  projectTitle?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface InternalOrderStatusView {
  orderViews?: OrderView[];
  destinationStatuses?: InternalOrderStatusView[];
  text?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  backgroundColor?: string;
  textColor?: string;
  categoryText?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface Link {
  annotations?: Annotation[];
  title?: string;
  rel?: string;
  href?: string;
  type?: string;
  mediaETag?: string;
  bindingLink?: string;
  bindingLinks?: string[];
  inlineEntity?: Entity;
  inlineEntitySet?: EntityCollection;
}

export interface NoteInstanceActionView {
  instanceType?: InstanceType;
  permission?: NotePermissionView;
  note?: NoteView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface NotePermissionActionView {
  instanceType?: InstanceType;
  permission?: NotePermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface NotePermissionView {
  instanceType?: InstanceType;
  actions?: NotePermissionActionView[];
  note?: NoteView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface NoteView {
  permissions?: NotePermissionView[];
  actions?: NoteInstanceActionView[];
  type?: NoteType;
  /** @format date-time */
  date?: string;
  order?: OrderView;
  description?: string;
  status?: NoteStatus;
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  component?: ComponentView;
  user?: UserView;
  type_Id?: string;
  guid?: string;
  assignedBy?: string;
  instanceType_Id?: string;
  documentation?: DocumentationView;
  instanceId?: string;
  status_Id?: string;
  project?: ProjectView;
  instanceType_Value?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  assignedBy_UserFullname?: string;
  assignedTo?: string;
  instanceTitle?: string;
  /** @format date-time */
  assignedOn?: string;
  status_Value?: string;
  instanceGuid?: string;
  instanceType?: InstanceType;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  files?: FileView[];
  klaesId?: string;
  title?: string;
  parentNote?: NoteView;
  childNotes?: NoteView[];
  createdBy_UserGuid?: string;
  issuedToClientTitle?: string;
  createdBy_UserFullname?: string;
  assignedTo_UserFullname?: string;
  orderLine?: OrderLineView;
  instanceTypeType_Value?: string;
  instanceTypeType_Id?: string;
}

export interface Operation {
  metadataAnchor?: string;
  title?: string;
  /** @format uri */
  target?: string;
  type?: Type;
}

export interface OrderInstanceActionView {
  instanceType?: InstanceType;
  permission?: OrderPermissionView;
  order?: OrderView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface OrderLabelTextView {
  text?: string;
  language_Value?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  language_Id?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  instanceGuid?: string;
  orderLabel?: OrderLabelView;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface OrderLabelView {
  text?: string;
  language_Value?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  backgroundColor?: string;
  fontColor?: string;
  orderLabelTexts?: OrderLabelTextView[];
  iconFileGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface OrderLineStatusContainer {
  status?: OrderLineStatus;
  internalAcceptanceStatus?: OrderLineInternalAcceptanceStatus;
  acceptanceStatus?: OrderLineAcceptanceStatus;
}

export interface OrderLineView {
  form?: FormView;
  order?: OrderView;
  description?: string;
  status?: OrderLineStatus;
  tag?: string;
  product?: ProductView;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  imageFileGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  component?: ComponentView;
  condition?: string;
  guid?: string;
  statusContainer?: OrderLineStatusContainer;
  /** @format date-time */
  plannedOn?: string;
  /** @format date-time */
  deliveryDate?: string;
  subType_Value?: string;
  versionValueAlu?: string;
  closedBy?: string;
  erpdocumentGuid?: string;
  /** @format int32 */
  quantity?: number;
  componentGuid?: string;
  deliveryWeek?: string;
  versionTextAlu?: string;
  subType_Id?: string;
  plannedBy?: string;
  internalAcceptanceStatus_Id?: string;
  internalAcceptanceStatus_Value?: string;
  internalAcceptanceStatus?: OrderLineInternalAcceptanceStatus;
  originGuid?: string;
  /** @format date-time */
  closedOn?: string;
  status_Id?: string;
  containerGuid?: string;
  projectGuid?: string;
  project?: ProjectView;
  originType_Id?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  productGuid?: string;
  documentations?: DocumentationView[];
  status_Value?: string;
  erpdocumentLineGuid?: string;
  documentationMappings?: DocumentationMappingView[];
  createdBy_ClientGuid?: string;
  files?: FileView[];
  klaesId?: string;
  title?: string;
  formGuid?: string;
  installationLocation?: string;
  deliveryDescription?: string;
  acceptanceStatus?: OrderLineAcceptanceStatus;
  acceptanceStatus_Id?: string;
  containerType_Id?: string;
  containerType_Value?: string;
  acceptanceStatus_Value?: string;
  originType_Value?: string;
  elementId?: string;
  orderType_Id?: string;
  orderId?: string;
  orderGuid?: string;
  orderType_Value?: string;
  notes?: NoteView[];
  lineNo?: string;
  updatedBy_UserFullname?: string;
  createdBy_UserFullname?: string;
  projectPartnerGuid?: string;
  orderTitle?: string;
  productName?: string;
  projectTitle?: string;
  pieceId?: string;
  closedBy_ClientTitle?: string;
  originDocumentation?: DocumentationView;
  closedBy_UserFullname?: string;
  componentTextShort?: string;
  positionElementPiece?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface OrderOrderLabelMappingView {
  order?: OrderView;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  orderLabelGuid?: string;
  orderLabel?: OrderLabelView;
  orderGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface OrderOrderMappingView {
  type?: OrderOrderMappingType;
  order?: OrderView;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  instanceGuid?: string;
  orderGuid?: string;
  instanceOrder?: OrderView;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface OrderPartnerView {
  order?: OrderView;
  type_Id?: string;
  partnerGuid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  title?: string;
  sid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface OrderPermissionActionView {
  instanceType?: InstanceType;
  permission?: OrderPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface OrderPermissionView {
  instanceType?: InstanceType;
  actions?: OrderPermissionActionView[];
  order?: OrderView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface OrderResourceMappingView {
  resource?: ResourceView;
  order?: OrderView;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  deletedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  /** @format date-time */
  deletedOn?: string;
  guid?: string;
  resourceGuid?: string;
  resourceCategory_ShortText?: string;
  resourceCategory_LongText?: string;
  files?: FileView[];
  resourceTitle?: string;
  orderGuid?: string;
  orderTitle?: string;
  resourceCategory_Id?: string;
  resourceDescription?: string;
  resourceCategory_Value?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface OrderStatusContainer {
  status?: OrderStatus;
  acceptanceStatus?: OrderAcceptanceStatus;
  planningStatus?: AppointmentStatus;
}

export interface OrderTeamMappingView {
  order?: OrderView;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  deletedBy?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  /** @format date-time */
  deletedOn?: string;
  guid?: string;
  teamGuid?: string;
  createdBy_ClientGuid?: string;
  files?: FileView[];
  orderResources?: OrderResourceMappingView[];
  orderGuid?: string;
  teamDescription?: string;
  teamTitle?: string;
  team?: TeamView;
  orderTitle?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface OrderView {
  deliveryAddress?: AddressView;
  customerAddress?: AddressView;
  actions?: OrderInstanceActionView[];
  id?: string;
  type?: OrderType;
  description?: string;
  status?: OrderStatus;
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  firstname?: string;
  updatedBy?: string;
  lastname?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  client?: ClientView;
  type_Id?: string;
  guid?: string;
  statusContainer?: OrderStatusContainer;
  timeRecords?: TimeRecordView[];
  tourNumber?: string;
  closedBy?: string;
  erpdocumentGuid?: string;
  /** @format date-time */
  productionDate?: string;
  assignedBy?: string;
  email?: string;
  internalStatusBackgroundColor?: string;
  orderLabelViews?: OrderLabelView[];
  /** @format date-time */
  plannedTo?: string;
  originGuid?: string;
  fileViews?: FileView[];
  permissionViews?: OrderPermissionView[];
  planningStatus?: PlanningStatus;
  contactViews?: ContactView[];
  /** @format date-time */
  closedOn?: string;
  orderLineViews?: OrderLineView[];
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  status_Id?: string;
  projectGuid?: string;
  project?: ProjectView;
  originType_Id?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  assignedBy_UserFullname?: string;
  contactPersonTelephone?: string;
  contactPersonEmail?: string;
  documentations?: DocumentationView[];
  appointments?: AppointmentView[];
  products?: ProductView[];
  assignedTo?: string;
  /** @format date-time */
  assignedOn?: string;
  status_Value?: string;
  country_Id?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  klaesId?: string;
  street?: string;
  zip?: string;
  city?: string;
  phone?: string;
  title?: string;
  houseNumber?: string;
  acceptanceStatus?: OrderAcceptanceStatus;
  acceptanceStatus_Id?: string;
  acceptanceStatus_Value?: string;
  originType_Value?: string;
  planningStatus_Id?: string;
  planningStatus_Value?: string;
  internalStatusGuid?: string;
  contactPerson?: string;
  country_Value?: string;
  originType?: OrderOriginType;
  orderMappings?: OrderOrderMappingView[];
  orderTeams?: OrderTeamMappingView[];
  hasAppointments?: boolean;
  orderResources?: OrderResourceMappingView[];
  assignedToUser?: UserView;
  deliveryAddressGuid?: string;
  customerAddressGuid?: string;
  partners?: OrderPartnerView[];
  notes?: NoteView[];
  createdBy_UserGuid?: string;
  projectProcessId?: string;
  createdBy_ClientTitle?: string;
  assignedTo_UserFullname?: string;
  updatedBy_ClientTitle?: string;
  projectPartnerGuid?: string;
  projectTitle?: string;
  internalStatusViews?: InternalOrderStatusView[];
  closedBy_UserFirstname?: string;
  closedBy_ClientTitle?: string;
  projectClientGuid?: string;
  updatedBy_UserLastname?: string;
  originDocumentation?: DocumentationView;
  internalStatusText?: string;
  deliveryAddressDetail?: Entity;
  internalStatusTextColor?: string;
  orderLabelMappings?: OrderOrderLabelMappingView[];
  customerAddressDetail?: Entity;
  closedBy_UserLastname?: string;
  updatedBy_UserFirstname?: string;
}

export interface PartnerDataInstanceActionView {
  instanceType?: InstanceType;
  permission?: PartnerDataPermissionView;
  partnerData?: PartnerDataView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface PartnerDataPermissionActionView {
  instanceType?: InstanceType;
  permission?: PartnerDataPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface PartnerDataPermissionView {
  instanceType?: InstanceType;
  actions?: PartnerDataPermissionActionView[];
  partnerData?: PartnerDataView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface PartnerDataView {
  value?: string;
  permissions?: PartnerDataPermissionView[];
  actions?: PartnerDataInstanceActionView[];
  description?: string;
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  /** @format int32 */
  isActive?: number;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  client?: ClientView;
  guid?: string;
  property_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  property_Id?: string;
  createdBy_UserGuid?: string;
  issuedToClientTitle?: string;
  createdBy_UserFullname?: string;
}

export interface ProductInstanceActionView {
  instanceType?: InstanceType;
  permission?: ProductPermissionView;
  product?: ProductView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ProductLabelView {
  text?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  fileViews?: FileView[];
  ruleViews?: RuleView[];
  fileMappingViews?: FileMappingView[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ProductLanguageView {
  name?: string;
  permissions?: ProductTextPermissionView[];
  actions?: ProductTextInstanceActionView[];
  description?: string;
  product?: ProductView;
  language_Value?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  language_Id?: string;
  /** @format date-time */
  updatedOn?: string;
  condition?: string;
  guid?: string;
  /** @format int32 */
  isDefault?: number;
  extSealCol?: string;
  erpcustomerText?: string;
  extBaseCol?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  title?: string;
  extLaminationCol?: string;
  extText?: string;
  extType?: string;
  issuedToClientTitle?: string;
}

export interface ProductPartnerView {
  product?: ProductView;
  type_Id?: string;
  partnerGuid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  title?: string;
  sid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ProductPermissionActionView {
  instanceType?: InstanceType;
  permission?: ProductPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ProductPermissionView {
  instanceType?: InstanceType;
  actions?: ProductPermissionActionView[];
  product?: ProductView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface ProductProductLabelMappingView {
  product?: ProductView;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  productGuid?: string;
  productLabelGuid?: string;
  productLabel?: ProductLabelView;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ProductTextInstanceActionView {
  instanceType?: InstanceType;
  permission?: ProductTextPermissionView;
  productLanguage?: ProductLanguageView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ProductTextPermissionActionView {
  instanceType?: InstanceType;
  permission?: ProductTextPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ProductTextPermissionView {
  instanceType?: InstanceType;
  actions?: ProductTextPermissionActionView[];
  productLanguage?: ProductLanguageView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface ProductView {
  height?: number;
  name?: string;
  permissions?: ProductPermissionView[];
  actions?: ProductInstanceActionView[];
  description?: string;
  tag?: string;
  width?: number;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  imageFileGuid?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  client?: ClientView;
  condition?: string;
  guid?: string;
  components?: ComponentView[];
  container?: ContainerView;
  erpdocumentGuid?: string;
  orderLines?: OrderLineView[];
  category?: ProductCategory;
  /** @format date-time */
  guaranteeFrom?: string;
  /** @format date-time */
  warrantyFrom?: string;
  /** @format date-time */
  guaranteeTill?: string;
  erpcustomerText?: string;
  /** @format date-time */
  warrantyTill?: string;
  uomValue?: UomMetreType;
  containerGuid?: string;
  fileMappings?: FileMappingView[];
  category_Id?: string;
  imageFile?: FileView;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  documentations?: DocumentationView[];
  erpdocumentLine?: ERPDocumentLineView;
  erpcoverFrames?: ERPCoverFrameView[];
  erpdocument?: ERPDocumentView;
  erpdocumentLineGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  productLabels?: ProductLabelView[];
  files?: FileView[];
  title?: string;
  containerType_Id?: string;
  containerType_Value?: string;
  /** @format int32 */
  erpfilesUploaded?: number;
  category_Value?: string;
  erpuploadId?: string;
  orderId?: string;
  uomId?: string;
  erpcomponents?: ComponentView[];
  projects?: ProjectView[];
  partners?: ProductPartnerView[];
  extText?: string;
  extType?: string;
  productLabelMappings?: ProductProductLabelMappingView[];
  productLanguages?: ProductLanguageView[];
  /** @format int32 */
  erpcoverFrameNumber?: number;
}

export interface ProjectInstanceActionView {
  instanceType?: InstanceType;
  permission?: ProjectPermissionView;
  project?: ProjectView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ProjectPartnerView {
  project?: ProjectView;
  type_Id?: string;
  partnerGuid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  title?: string;
  sid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ProjectPermissionActionView {
  instanceType?: InstanceType;
  permission?: ProjectPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ProjectPermissionView {
  instanceType?: InstanceType;
  actions?: ProjectPermissionActionView[];
  project?: ProjectView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface ProjectView {
  processId?: string;
  permissions?: ProjectPermissionView[];
  actions?: ProjectInstanceActionView[];
  address?: AddressView;
  region?: string;
  description?: string;
  status?: ProjectStatus;
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  firstname?: string;
  imageFileGuid?: string;
  lastname?: string;
  addressGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  containerType?: ContainerType;
  guid?: string;
  components?: ComponentView[];
  email?: string;
  partnerGuid?: string;
  addressPresent?: boolean;
  addressTitle?: string;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  status_Id?: string;
  containerGuid?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  orders?: OrderView[];
  logo?: FileView;
  contactPersonTelephone?: string;
  contactPersonEmail?: string;
  documentations?: DocumentationView[];
  products?: ProductView[];
  contacts?: ContactView[];
  salutationValue?: string;
  status_Value?: string;
  country_Id?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  klaesId?: string;
  street?: string;
  zip?: string;
  city?: string;
  phone?: string;
  title?: string;
  houseNumber?: string;
  containerType_Id?: string;
  containerType_Value?: string;
  addressDescription?: string;
  addressType_Value?: string;
  contactPerson?: string;
  country_Value?: string;
  salutationId?: string;
  addressType_Id?: string;
  fileDetails?: FileView[];
  orderId?: string;
  partners?: ProjectPartnerView[];
  name01?: string;
  name02?: string;
  notes?: NoteView[];
  remark?: string;
  place?: string;
  createdBy_ClientTitle?: string;
  /** @format int32 */
  countNoteDetails?: number;
}

export interface Property {
  annotations?: Annotation[];
  valueType?: ValueType;
  value?: object;
  type?: string;
  name?: string;
  operations?: Operation[];
  null?: boolean;
  primitive?: boolean;
  enum?: boolean;
  geospatial?: boolean;
  collection?: boolean;
  complex?: boolean;
}

export interface ResourceInstanceActionView {
  instanceType?: InstanceType;
  resource?: ResourceView;
  permission?: ResourcePermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ResourcePermissionActionView {
  instanceType?: InstanceType;
  permission?: ResourcePermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ResourcePermissionView {
  instanceType?: InstanceType;
  resource?: ResourceView;
  actions?: ResourcePermissionActionView[];
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface ResourceView {
  permissions?: ResourcePermissionView[];
  actions?: ResourceInstanceActionView[];
  description?: string;
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  category?: ResourceCategory;
  category_Id?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  teamMembers?: TeamMemberView[];
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  files?: FileView[];
  klaesId?: string;
  title?: string;
  category_Value?: string;
  orderResources?: OrderResourceMappingView[];
  createdBy_UserGuid?: string;
  issuedToClientTitle?: string;
  createdBy_UserFullname?: string;
}

export interface RoleView {
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  user?: UserView;
  roleId?: string;
  userGuid?: string;
  sid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface RuleOptionView {
  value?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  check_Id?: string;
  check_Value?: string;
  instanceGuid?: string;
  rule?: RuleView;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface RuleView {
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  instanceType_Id?: string;
  entityType_Id?: string;
  instanceType_Value?: string;
  valueHelpView?: ValueHelpView;
  instanceGuid?: string;
  instanceType?: InstanceType;
  entityType_Value?: string;
  entityAttribute_Value?: string;
  ruleOptionDetails?: RuleOptionView[];
  entityAttribute_Id?: string;
  productLabel?: ProductLabelView;
  componentLabel?: ComponentLabelView;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface SubscriptionView {
  value?: string;
  guid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface TeamInstanceActionView {
  instanceType?: InstanceType;
  permission?: TeamPermissionView;
  team?: TeamView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface TeamMemberView {
  resource?: ResourceView;
  description?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  deletedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  /** @format date-time */
  deletedOn?: string;
  client?: ClientView;
  guid?: string;
  instanceType_Id?: string;
  instanceType_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  teamGuid?: string;
  instanceTitle?: string;
  isTeamLead?: boolean;
  instanceGuid?: string;
  createdBy_ClientGuid?: string;
  instanceDescription?: string;
  files?: FileView[];
  title?: string;
  user?: UserView;
  team?: TeamView;
  permissionActions?: BasePermissionActionView[];
}

export interface TeamPermissionActionView {
  instanceType?: InstanceType;
  permission?: TeamPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface TeamPermissionView {
  instanceType?: InstanceType;
  actions?: TeamPermissionActionView[];
  team?: TeamView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface TeamView {
  permissions?: TeamPermissionView[];
  actions?: TeamInstanceActionView[];
  description?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  deletedBy?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  /** @format date-time */
  deletedOn?: string;
  guid?: string;
  assignedBy?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  teamMembers?: TeamMemberView[];
  color_Value?: string;
  assignedTo?: string;
  /** @format date-time */
  assignedOn?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  files?: FileView[];
  title?: string;
  orderTeam?: OrderTeamMappingView[];
}

export interface TimeRecordInstanceActionView {
  instanceType?: InstanceType;
  permission?: TimeRecordPermissionView;
  timeRecord?: TimeRecordView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface TimeRecordPermissionActionView {
  instanceType?: InstanceType;
  permission?: TimeRecordPermissionView;
  type?: ActionType;
  type_Id?: string;
  guid?: string;
  type_Value?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  permissionGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface TimeRecordPermissionView {
  instanceType?: InstanceType;
  actions?: TimeRecordPermissionActionView[];
  timeRecord?: TimeRecordView;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  clientPermission?: boolean;
  instanceGuid?: string;
  issuedTo_ClientGuid?: string;
  createdBy_ClientGuid?: string;
  issuedTo_UserGuid?: string;
  createdBy_UserGuid?: string;
  issuedTo_ClientTitle?: string;
  issuedTo_UserFullname?: string;
  permissionActions?: BasePermissionActionView[];
}

export interface TimeRecordView {
  permissions?: TimeRecordPermissionView[];
  actions?: TimeRecordInstanceActionView[];
  /** @format date-time */
  date?: string;
  order?: OrderView;
  /** @format double */
  minutes?: number;
  comment?: string;
  product?: ProductView;
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  createdBy?: string;
  /** @format date-time */
  createdOn?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedOn?: string;
  user?: UserView;
  guid?: string;
  instanceType_Id?: string;
  documentation?: DocumentationView;
  instanceType_Value?: string;
  userGuid?: string;
  issuedToClientGuid?: string;
  issuedToUserGuid?: string;
  instanceGuid?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
  createdFor_UserFirstname?: string;
  createdBy_UserEmail?: string;
  createdFor_UserGuid?: string;
  createdFor_ClientTitle?: string;
  createdFor_ClientGuid?: string;
  createdFor_UserLastname?: string;
  createdFor_UserEmail?: string;
  issuedToClientTitle?: string;
  createdBy_ClientTitle?: string;
  orderLine?: OrderLineView;
}

export interface UserConfigurationView {
  value?: string;
  /** @format int32 */
  counter?: number;
  /** @format int32 */
  isActive?: number;
  /** @format date-time */
  createdOn?: string;
  /** @format int32 */
  isDeleted?: number;
  /** @format date-time */
  updatedOn?: string;
  user?: UserView;
  configurationDescription?: string;
  userGuid?: string;
  applicationId?: string;
  configurationId?: string;
  sid?: string;
  applicationDescription?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface UserView {
  image?: FileView;
  type?: UserType;
  description?: string;
  /** @format date-time */
  lastAccess?: string;
  /** @format date-time */
  validFrom?: string;
  /** @format int32 */
  isActive?: number;
  language_Value?: string;
  /** @format date-time */
  createdOn?: string;
  firstname?: string;
  imageFileGuid?: string;
  telephone?: string;
  lastname?: string;
  salutation_Id?: string;
  /** @format date-time */
  validTill?: string;
  language_Id?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  client?: ClientView;
  mobile?: string;
  type_Id?: string;
  roles?: RoleView[];
  guid?: string;
  fax?: string;
  username?: string;
  salutation_Value?: string;
  email?: string;
  clientTitle?: string;
  erpCreator?: string;
  type_Value?: string;
  activationChangedBy?: string;
  /** @format date-time */
  activationChangedOn?: string;
  userConfigurations?: UserConfigurationView[];
  appointments?: AppointmentView[];
  country_Id?: string;
  userFullname?: string;
  aclUserEntities?: AclUserEntityView[];
  street?: string;
  zip?: string;
  city?: string;
  houseNumber?: string;
  country_Value?: string;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ValueHelpTextView {
  valueHelpView?: ValueHelpView;
  value?: string;
  /** @format date-time */
  createdOn?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  textShort?: string;
  textLong?: string;
  languageValue?: string;
  languageId?: string;
  valueHelpGuid?: string;
  /** @format int32 */
  ranking?: number;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface ValueHelpView {
  ruleViews?: RuleView[];
  valueHelpTextViews?: ValueHelpTextView[];
  value?: string;
  id?: string;
  /** @format date-time */
  createdOn?: string;
  clientGuid?: string;
  /** @format date-time */
  updatedOn?: string;
  guid?: string;
  textShort?: string;
  textLong?: string;
  languageValue?: string;
  languageId?: string;
  files?: FileView[];
  iconFileGuid?: string;
  /** @format int32 */
  isExpandable?: number;
  iconDetails?: FileView;
  /** @format int32 */
  ranking?: number;
  permissionActions?: BasePermissionActionView[];
  createdBy_ClientGuid?: string;
}

export interface WinDoFlowResponseDocumentationDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: DocumentationDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface DocumentationInputTemplateDto {
  value?: string;
  /** @format int32 */
  counter?: number;
  formInputGuid?: string;
  /** @format int32 */
  isMandatory?: number;
  formInputDetailDefaultValue?: string;
  formInputDetailDescription?: string;
  status_Id?: string;
  status_Value?: string;
  formGuid?: string;
  formInputParentId?: string;
  /** @format int32 */
  formInputDetailPosition?: number;
  /** @format int32 */
  formInputPosition?: number;
  formInputClientGuid?: string;
  formInputDetailGuid?: string;
  formInputDescription?: string;
  formInputType_Value?: string;
}

export interface DocumentationSignatureDto {
  typeValue?: string;
  isRequired?: boolean;
  typeId?: string;
}

export interface DocumentationTemplateDto {
  createdBy_UserFirstname?: string;
  createdBy_UserLastname?: string;
  status_Id?: string;
  orderLineGuid?: string;
  formClientGuid?: string;
  /** @format int32 */
  isServerManaged?: number;
  issuedToClientGuid?: string;
  productGuid?: string;
  status_Value?: string;
  formType_Value?: string;
  formGuid?: string;
  documentationInputDetails?: DocumentationInputTemplateDto[];
  formType_Id?: string;
  orderGuid?: string;
  formTemplateGuid?: string;
  createdBy_UserGuid?: string;
  createdBy_UserUsername?: string;
  signatureDetails?: DocumentationSignatureDto[];
}

export interface WinDoFlowResponseListDocumentationTemplateDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: DocumentationTemplateDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface ActivationDataFlavor {
  mimeType?: string;
  humanPresentableName?: string;
}

export interface Attachment {
  headers?: {
    empty?: boolean;
    [key: string]: any;
  };
  object?: object;
  contentType?: MediaType;
  dataHandler?: DataHandler;
  contentDisposition?: ContentDisposition;
  contentId?: string;
}

export interface CommandInfo {
  commandName?: string;
  commandClass?: string;
}

export interface CommandMap {
  mimeTypes?: string[];
}

export interface ContentDisposition {
  type?: string;
  parameters?: Record<string, string>;
  filename?: string;
}

export interface DataHandler {
  commandMap?: CommandMap;
  name?: string;
  inputStream?: object;
  content?: object;
  outputStream?: object;
  contentType?: string;
  allCommands?: CommandInfo[];
  preferredCommands?: CommandInfo[];
  transferDataFlavors?: ActivationDataFlavor[];
  dataSource?: DataSource;
}

export interface DataSource {
  name?: string;
  inputStream?: object;
  outputStream?: object;
  contentType?: string;
}

export interface MediaType {
  type?: string;
  subtype?: string;
  parameters?: Record<string, string>;
  wildcardType?: boolean;
  wildcardSubtype?: boolean;
}

export interface MultivaluedMapStringString {
  empty?: boolean;
  [key: string]: any;
}

export interface ErpClientDto {
  clientId?: string;
}

export interface ErpClientsDto {
  clients?: ErpClientDto[];
}

export interface AccessoryComponentRuleDto {
  guid?: string;
  description?: string;
  articleClass?: string;
}

export interface AccessoryFieldRuleDto {
  guid?: string;
  /** @format int32 */
  dependentArticleClass?: number;
  /** @format int32 */
  dependentCode?: number;
  dependentValue?: string;
  /** @format int32 */
  checkArticleClass?: number;
  checkCode?: string;
  targetEntity?: string;
  targetEntityField?: string;
  checkTypeValue?: AccessoryFieldRuleCheckType;
  checkValue?: AccessoryFieldRuleCheck;
}

export interface CantorSettingsDto {
  accessoryComponentRules?: AccessoryComponentRuleDto[];
  accessoryFieldRules?: AccessoryFieldRuleDto[];
  couplePositionIgnoreRules?: CouplePositionIgnoreRuleDto[];
}

export interface CouplePositionIgnoreRuleDto {
  guid?: string;
  description?: string;
  articleClass?: string;
}

export interface ErpSettingsDto {
  erpInterface?: ErpInterface;
  projectSourceAddress?: AddressType;
  orderType?: OrderType;
  handlingFrameCouplings?: ErpConfigTypeCoupleElements;
  orderRules?: RuleDto[];
  fileRules?: RuleDto[];
  cantor?: CantorSettingsDto;
}

export interface RuleDto {
  guid?: string;
  instanceType?: InstanceType;
  instanceGuid?: string;
  entityTypeId?: string;
  entityTypeValue?: string;
  entityAttributeId?: string;
  entityAttributeValue?: string;
  options?: RuleOptionDto[];
}

export interface RuleOptionDto {
  guid?: string;
  value?: string;
  checkValue?: RuleOptionCheckValue;
}

export interface WinDoFlowResponseErpSettingsDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: ErpSettingsDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface ErpTransferDto {
  isChecked?: boolean;
}

export interface EntityGeneratorResponse {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: object;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface EntityGeneratorRequest {
  containerType_Id?: string;
  containerType_Value?: string;
  objectType_Id?: string;
  objectType_Value?: string;
  orderType_Id?: string;
  orderType_Value?: string;
  type?: string;
  mode?: string;
  partnerGuid?: string;
  target?: string;
  erpDocumentGuids?: string[];
  projectAddressType?: string;
  erpDocumentGuid?: string;
}

export interface WinDoFlowResponseString {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: string;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface SignatureData {
  signatureTitle?: string;
  signatureType?: string;
  signatureAsBase64?: string;
  type?: SignatureType;
}

export interface SignedPdfRequest {
  signatures?: SignatureData[];
}

export interface WinDoFlowResponseFileMappingView {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: FileMappingView;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseFileView {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: FileView;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseListString {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: string[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseObject {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: object;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface ClientUserCountDTO {
  clientGuid?: string;
  clientName?: string;
  /** @format int32 */
  userCount?: number;
  /** @format int32 */
  newUserCount?: number;
}

export interface WinDoFlowResponseListClientUserCountDTO {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: ClientUserCountDTO[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface ValueHelpDto {
  guid?: string;
  textShort?: string;
  textLong?: string;
  id?: string;
  value?: string;
  /** @format int32 */
  ranking?: number;
}

export interface WinDoFlowResponseListValueHelpDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: ValueHelpDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoPassConfigRequest {
  configurationValues?: WinDoPassConfigValueRequest[];
}

export interface AppointmentConfigRequest {
  appointmentConfigGuid?: string;
  calendarType?: string;
  propertiesFirstLine?: string[];
  propertiesSecondLine?: string[];
  propertiesThirdLine?: string[];
  propertiesFourthLine?: string[];
}

export interface AppointmentResourceRequest {
  status_Id?: string;
  status_Value?: string;
  instanceGuid?: string;
}

export interface AppointmentSeriesDto {
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  repetitionType?: AppointmentSeriesRepetitionType;
  /** @format int32 */
  repetitionInterval?: number;
  daysOfWeek?: DayOfWeek[];
}

export interface CreateUpdateRequest {
  appointmentSeries?: AppointmentSeriesDto;
  resources?: AppointmentResourceRequest[];
  description?: string;
  /** @format date-time */
  start?: string;
  /** @format date-time */
  end?: string;
  guid?: string;
  users?: string[];
  orderLines?: string[];
  type_Value?: string;
  clients?: string[];
  status_Value?: string;
  klaesId?: string;
  title?: string;
  teams?: string[];
  orderGuid?: string;
}

export interface WinDoFlowResponseBoolean {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: boolean;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseAppointmentSeriesDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: AppointmentSeriesDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface PartnerDto {
  clientTitle?: string;
  clientType?: ClientType;
  clientId?: string;
  email?: string;
  phone?: string;
  street?: string;
  houseNumber?: string;
  zip?: string;
  city?: string;
  countryIso?: string;
  sendInvitation?: boolean;
  firstName?: string;
  lastName?: string;
  showInWinDoPass?: boolean;
}

export interface PartnersDto {
  partnerDtoList?: PartnerDto[];
}

export interface UserDto {
  guid?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  language?: string;
  imageGuid?: string;
  client?: CurrentClientDto;
  roles?: string[];
  acl?: AclDto[];
  configurations?: ConfigurationDto[];
}

export interface WinDoFlowResponseListUserDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: UserDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface ProjectModuleDto {
  clientGuid?: string;
  isActive?: boolean;
  userGuid?: string;
}

export interface ClientSubscriptionMappingDto {
  guids?: string[];
}

export interface FilterResponse {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: object;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  guid?: string;
  httpStatus?: HttpStatusCode;
}

export interface FilterResponseCopy {
  filters?: FilterResponse[];
}

export interface FilterRequestCopy {
  guids?: string[];
}

export interface FilterColumnRequest {
  /** @format int32 */
  rank?: number;
  title?: string;
  order?: string;
}

export interface FilterPropertyRequest {
  guid?: string;
  propertyField?: string;
  propertyType?: string;
  propertyValue?: string;
}

export interface FilterRequestCreate {
  title: string;
  instanceType_Value: string;
  orderBy_Field: string;
  orderBy_Type: string;
  /** @format int32 */
  isPublic?: number;
  /** @format int32 */
  isDefault?: number;
  filterProperties?: FilterPropertyRequest[];
  filterColumns?: FilterColumnRequest[];
}

export interface FilterRequestUpdate {
  guid?: string;
  title?: string;
  instanceType_Value?: string;
  orderBy_Field?: string;
  orderBy_Type?: string;
  /** @format int32 */
  isPublic?: number;
  /** @format int32 */
  isDefault?: number;
  filterProperties?: FilterPropertyRequest[];
  filterColumns?: FilterColumnRequest[];
}

export interface FormDto {
  guid?: string;
  title?: string;
  category?: FormCategory;
  templateGuid?: string;
  isUsedForOrder?: boolean;
  isUsedForOrderLine?: boolean;
  formInputs?: MappedFormInputDto[];
  signatures?: SignatureDto[];
  productCategories?: ProductCategoryDto[];
  formTypes?: FormTypeDto[];
}

export interface FormInputPropDto {
  guid?: string;
  description?: string;
  /** @format int32 */
  position?: number;
}

export interface FormTypeDto {
  typeValue?: FormType;
}

export interface MappedFormInputDto {
  guid?: string;
  parentGuid?: string;
  children?: MappedFormInputDto[];
  properties?: FormInputPropDto[];
  /** @format int32 */
  position?: number;
  isMandatory?: boolean;
  isUsedInternally?: boolean;
  isUsedExternally?: boolean;
  description?: string;
  typeValue?: FormInputType;
  sid?: string;
  sId?: string;
}

export interface ProductCategoryDto {
  typeValue?: ProductCategory;
}

export interface SignatureDto {
  guid?: string;
  typeValue?: SignatureType;
  isRequired?: boolean;
}

export interface WinDoFlowResponseFormDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: FormDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface OrderInternalOrderStatusMappingDto {
  guid?: string;
  orderGuid?: string;
  description?: string;
  createdByFullName?: string;
  /** @format date-time */
  createdOn?: string;
  statusGuid?: string;
  statusText?: string;
  statusTextColor?: string;
  statusBackgroundColor?: string;
}

export interface WinDoFlowResponseOrderInternalOrderStatusMappingDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: OrderInternalOrderStatusMappingDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseListOrderInternalOrderStatusMappingDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: OrderInternalOrderStatusMappingDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface UpdateRequestDto {
  description?: string;
}

export interface OrderLabelRequest {
  guid?: string;
  backgroundColor?: string;
  fontColor?: string;
  orderLabelTexts?: OrderLabelTextRequest[];
  iconFileGuid?: string;
}

export interface OrderLabelTextRequest {
  text?: string;
  language_Value?: string;
  guid?: string;
}

export interface OrderOrderLabelMappingRequest {
  orderLabelGuid?: string;
  orderGuid?: string;
}

export interface AddOrderMappingRequest {
  mappingEntities?: OrderMappingEntity[];
  orderGuid?: string;
}

export interface OrderMappingEntity {
  type?: OrderOrderMappingType;
  typeValue?: string;
  instanceGuid?: string;
  typeId?: string;
}

export interface OrderCopierRequest {
  permissions?: string[];
  id?: string;
  description?: string;
  addresses?: string[];
  type_Id?: string;
  guid?: string;
  tourNumber?: string;
  orderLineGuids?: string[];
  /** @format date-time */
  plannedTo?: string;
  withPrincipal?: boolean;
  status_Id?: string;
  type_Value?: string;
  contactPersonTelephone?: string;
  contactPersonEmail?: string;
  assignedTo?: string;
  status_Value?: string;
  files?: string[];
  title?: string;
  acceptanceStatus_Id?: string;
  acceptanceStatus_Value?: string;
  contactPerson?: string;
  /** @format int32 */
  moveOrderLines?: number;
  /** @format date-time */
  plannedFrom?: string;
}

export interface TagMarryDto {
  tagValue?: string;
  orderLineGuid?: string;
  scanType?: ScanType;
}

export interface TagScanHistoryDto {
  orderId?: string;
  orderTitle: string;
  position?: string;
  tagId?: string;
  scanType?: ScanType;
  status?: ScanStatusType;
  /** @format date-time */
  scanTime: string;
}

export interface TagScanHistoryWeekDayDto {
  dayOfWeek: string;
  displayName?: string;
  /** @format date-time */
  dayOfWeekTime: string;
  tagScanHistoryDtos?: TagScanHistoryDto[];
}

export interface WinDoFlowResponseListTagScanHistoryWeekDayDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: TagScanHistoryWeekDayDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface ClientPermissionDto {
  instanceGuid?: string;
  clientGuid?: string;
}

export interface ProfiledRequestDto {
  id?: string;
  /** @format int64 */
  startTime?: number;
  /** @format int64 */
  endTime?: number;
  /** @format int64 */
  duration?: number;
  /** @format int32 */
  response?: number;
  method?: HttpMethod;
  call?: string;
  userName?: string;
  userMail?: string;
  requestHeader?: string;
  requestBody?: string;
  responseHeader?: string;
  responseBody?: string;
}

export interface WinDoFlowResponseProfiledRequestDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: ProfiledRequestDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseListProfiledRequestDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: ProfiledRequestDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface EntityMergerResponse {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: object;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface EntityMergerRequest {
  instanceType_Id?: string;
  instanceType_Value?: string;
  targetGuid?: string;
  sourceGuid?: string[];
}

export interface EntityRestoreRequest {
  guid?: string;
  instanceTypeValue?: string;
}

export interface ClientResponse {
  hasTermsOfUse?: boolean;
  hasDataProtection?: boolean;
}

export interface UserResponse {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: object;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  guid?: string;
  username?: string;
  email?: string;
  validFrom?: string;
  validTill?: string;
  lastAccess?: string;
  firstname?: string;
  lastname?: string;
  telephone?: string;
  fax?: string;
  salutation_Id?: string;
  salutation_Value?: string;
  mobile?: string;
  street?: string;
  zip?: string;
  city?: string;
  description?: string;
  houseNumber?: string;
  imageFileGuid?: string;
  country_Id?: string;
  country_Value?: string;
  updatedOn?: string;
  language_Id?: string;
  language_Value?: string;
  createdOn?: string;
  clientGuid?: string;
  type_Id?: string;
  type_Value?: string;
  activationChangedBy?: string;
  activationChangedOn?: string;
  /** @format int32 */
  isActive?: number;
  client?: ClientResponse;
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseListUserResponse {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: UserResponse[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface PartnerServiceRequest {
  guid?: string[];
}

export interface PartnerInfoResponse {
  showGenerateButton?: boolean;
  showWinDoPassConfigurationButton?: boolean;
  showListTagsButton?: boolean;
}

export interface WinDoFlowResponsePartnerInfoResponse {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: PartnerInfoResponse;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface PartnerServiceResponse {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: object;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  partnerGuid?: string;
  httpStatus?: HttpStatusCode;
}

export type ObjectNode = object;

export interface WinDoFlowResponseObjectNode {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: ObjectNode;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface KlaesAppointmentOrderLineMappingDto {
  guid?: string;
  appointmentGuid?: string;
  orderLineGuid?: string;
}

export interface WinDoFlowResponseKlaesAppointmentOrderLineMappingDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesAppointmentOrderLineMappingDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface KlaesAppointmentResourceMappingDto {
  guid?: string;
  appointmentGuid?: string;
  resourceGuid?: string;
  status?: string;
}

export interface WinDoFlowResponseKlaesAppointmentResourceMappingDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesAppointmentResourceMappingDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface KlaesAppointmentDto {
  guid?: string;
  klaesId?: string;
  orderGuid?: string;
  type?: string;
  status?: string;
  /** @format date-time */
  start?: string;
  /** @format date-time */
  end?: string;
  description?: string;
  orderLines?: KlaesOrderLineDto[];
  resources?: KlaesResourceDto[];
  users?: KlaesUserDto[];
}

export interface KlaesComponentDto {
  orderLineGuid?: string;
  productGuid?: string;
  componentGuid?: string;
  title?: string;
  note?: string;
  /** @format double */
  netPrice?: number;
  category?: string;
  textShort?: string;
  textLong?: string;
  /** @format double */
  quantity?: number;
  quantityUomId?: string;
  quantityUomValue?: string;
  /** @format double */
  weight?: number;
  weightUom?: string;
  customerText?: string;
  /** @format double */
  width?: number;
  /** @format double */
  height?: number;
  measurementUom?: string;
  /** @format int32 */
  isInternal?: number;
  /** @format int32 */
  isAlternative?: number;
  /** @format int32 */
  isDemand?: number;
  /** @format int32 */
  isAddition?: number;
  components?: KlaesComponentDto[];
  subComponent?: boolean;
  mappedComponentView?: ComponentView;
}

export interface KlaesOrderLineDto {
  klaesId?: string;
  lineNo?: string;
  title?: string;
  /** @format int32 */
  quantity?: number;
  installationLocation?: string;
  description?: string;
  orderGuid?: string;
  guid?: string;
  product?: KlaesProductDto;
  component?: KlaesComponentDto;
}

export interface KlaesProductDto {
  guid?: string;
  name?: string;
  category?: ProductCategory;
  description?: string;
  /** @format double */
  width?: number;
  widthUom?: UomMetreType;
  /** @format double */
  height?: number;
  heightUom?: UomMetreType;
  image?: string;
  components?: KlaesComponentDto[];
  mappedProductView?: ProductView;
}

export interface KlaesResourceDto {
  guid?: string;
  klaesId?: string;
  title?: string;
  category?: string;
  description?: string;
  status?: string;
}

export interface KlaesUserDto {
  email?: string;
}

export interface WinDoFlowResponseKlaesAppointmentDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesAppointmentDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseListKlaesAppointmentOrderLineMappingDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesAppointmentOrderLineMappingDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseListKlaesAppointmentResourceMappingDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesAppointmentResourceMappingDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface KlaesAppointmentUserMappingDto {
  guid?: string;
  appointmentGuid?: string;
  email?: string;
}

export interface WinDoFlowResponseListKlaesAppointmentUserMappingDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesAppointmentUserMappingDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseKlaesAppointmentUserMappingDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesAppointmentUserMappingDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface KlaesNoteDto {
  guid?: string;
  klaesId?: string;
  instanceType?: string;
  instanceGuid?: string;
  title?: string;
  type?: string;
  description?: string;
  /** @format date-time */
  date?: string;
}

export interface WinDoFlowResponseKlaesNoteDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesNoteDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseKlaesOrderLineDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesOrderLineDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface KlaesAddressDto {
  street?: string;
  zip?: string;
  city?: string;
  countryIsoCode?: string;
  klaesId?: string;
}

export interface KlaesContactDto {
  name?: string;
  email?: string;
  phone?: string;
}

export interface KlaesOrderDto {
  guid?: string;
  klaesId?: string;
  projectId?: string;
  orderId?: string;
  type?: string;
  title?: string;
  description?: string;
  tourNumber?: string;
  /** @format date-time */
  dueDate?: string;
  contactPerson?: KlaesContactDto;
  deliveryAddress?: KlaesAddressDto;
  customerAddress?: KlaesAddressDto;
  orderLines?: KlaesOrderLineDto[];
}

export interface WinDoFlowResponseKlaesOrderDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesOrderDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseListKlaesOrderLineDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesOrderLineDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseKlaesResourceDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesResourceDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseListKlaesResourceDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: KlaesResourceDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface AclDto {
  instanceType?: string;
  actionType?: string;
}

export interface ConfigurationDto {
  sid?: string;
  systemId?: string;
  value?: string;
}

export interface CurrentClientDto {
  guid?: string;
  title?: string;
  type?: ClientType;
  hasDataProtection?: boolean;
  hasFlowSubscription?: boolean;
  modules?: string[];
  employees?: UserDto[];
  configurations?: ConfigurationDto[];
  subscriptions?: SubscriptionType[];
}

export interface WinDoFlowResponseUserDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: UserDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface UserServiceRequest {
  guids?: string[];
}

export interface OrderLineCountDto {
  orderGuid?: string;
  /** @format int32 */
  orderLineCount?: number;
}

export interface WinDoFlowResponseListOrderLineCountDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: OrderLineCountDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoFlowResponseListWinDoPassFileDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: WinDoPassFileDto[];
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoPassFileDto {
  name?: string;
  /** @format int32 */
  bytes?: number;
  typeValue?: string;
  categoryId?: string;
  categoryValue?: string;
  link?: string;
  /** @format date-time */
  createdOn?: string;
}

export interface LegalAgreementDto {
  company?: string;
  companyAddress?: string;
  contactPerson?: string;
  contactPersonEmail?: string;
  contactPersonPhone?: string;
}

export interface WinDoFlowResponseWinDoPassLegalAgreementDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: WinDoPassLegalAgreementDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoPassLegalAgreementDto {
  legalAgreement?: LegalAgreementDto;
  files?: WinDoPassFileDto[];
}

export interface WinDoFlowResponseWinDoPassConfigResponse {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: WinDoPassConfigResponse;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}

export interface WinDoPassConfig {
  clientGuid?: string;
  typeId?: string;
  typeValue?: string;
  value?: string;
  type?: WinDoPassConfigType;
  /** @format date-time */
  deletedOn?: string;
  /** @format date-time */
  updatedOn?: string;
  /** @format date-time */
  createdOn?: string;
  isDeleted?: boolean;
  deletedBy?: string;
  deleted?: boolean;
  createdBy?: string;
  updatedBy?: string;
  empty?: boolean;
  guid?: string;
  isNew?: boolean;
  new?: boolean;
}

export interface WinDoPassConfigResponse {
  configurations?: WinDoPassConfig[];
}

export interface WinDoPassConfigDeleteRequest {
  typeValues?: string[];
}

export interface WinDoPassConfigValueRequest {
  typeValue?: string;
  value?: string;
}

export interface ContentCenterEntryDto {
  type?: string;
  language?: string;
  title?: string;
  description?: string;
}

export interface WinDoFlowResponseContentCenterEntryDto {
  status?: ResponseStatus;
  errorCode?: ResponseErrorCode;
  message?: string;
  content?: ContentCenterEntryDto;
  requestId?: string;
  additionalInfo?: Record<string, object>[];
  httpStatus?: HttpStatusCode;
}
